// UI copy that used to be hard-coded English in components (alerts, gates, deep-link errors,
// family leaderboard, web plan cards). Read it with uiText()/useUiText() from shared/utils/uiText.
export const uiCopy = {
  en: {
    successBang: 'Success!',
    great: 'Great!',
    billingUpdatedTitle: 'Billing Updated!',
    billingSwitchedAnnual: 'Your billing has been switched to annual payments. You\'re now saving {{percent}}% annually!',
    billingSwitchedMonthly: 'Your billing has been switched to monthly payments. Your next payment will be monthly.',
    billingChangeFailedTitle: 'Billing Change Failed',
    billingChangeFailedMessage: 'Unable to change your billing cycle. Please try again.',
    planUpgraded: 'Your subscription has been upgraded to {{plan}}. Your new features are now active!',
    planDowngraded: 'Your subscription has been downgraded to {{plan}}. Your new features are now active!',
    planChanged: 'Your subscription has been changed to {{plan}}. Your new features are now active!',
    planChangeFailedTitle: 'Plan Change Failed',
    planChangeFailedMessage: 'Unable to change your plan. Please try again.',
    subscriptionActivated: 'Your subscription has been activated. Thank you!',
    purchasesRestoredTitle: 'Purchases Restored',
    purchasesRestoredMessage: 'Successfully restored {{count}} subscription(s)',
    stripeSignInMessage: 'Please sign in or create an account before starting Stripe Checkout. Your guest progress can be migrated after sign-in.',
    previewSuccess: 'Subscription simulated successfully! In live mode, payment would be processed.',
    welcomeSubscription: 'Welcome to your new subscription! Your premium features are now active.',
    processSubscriptionFailed: 'Unable to process subscription. Please try again.',
    startGameFailedTitle: 'Start Game Failed',
    joinRoomFailed: 'Failed to join room. Please try again.',
    joinRoomFailedWithReason: 'Failed to join room: {{message}}',
    unknownError: 'Unknown error',
    sharedSuccessTitle: 'Shared Successfully!',
    sharedSuccessMessage: 'Your quiz has been shared via {{platform}}. Thank you for spreading biblical knowledge!',
    shareAnother: 'Share Another',
    sharingFailedTitle: 'Sharing Failed',
    sharingFailedMessage: 'Unable to share via {{platform}}. Please try again.',
    sharingErrorTitle: 'Sharing Error',
    sharingErrorMessage: 'An error occurred while sharing to {{platform}}. Please try again.',
    platformSharingTitle: '{{platform}} Sharing',
    soonInstagram: 'Instagram sharing will open the Instagram app with pre-filled content. This feature is coming soon!',
    soonTikTok: 'TikTok sharing will create engaging video content from your quiz question. This feature is coming soon with interactive video templates!',
    soonSnapchat: 'Snapchat sharing will create visual stories from your quiz questions. This feature is coming soon!',
    soonYouTube: 'YouTube sharing allows you to post quiz content to your community tab or video descriptions. This feature is coming soon!',
    linkCopiedTitle: 'Link Copied!',
    linkCopiedMessage: 'The quiz link has been copied to your clipboard. You can now paste it anywhere you want to share.',
    shareToSlack: 'Share to Slack',
    shareToTeams: 'Share to Microsoft Teams',
    shareToDiscord: 'Share to Discord',
    pasteSlack: 'Content copied to clipboard! Open Slack and paste this in your desired channel or DM.',
    pasteTeams: 'Content copied to clipboard! Open Microsoft Teams and paste this in your desired chat or channel.',
    pasteDiscord: 'Content copied to clipboard! Open Discord and paste this in your desired server or DM.',
    downloadAppTitle: 'Download Kingdom Bible Quiz',
    downloadAppMessage: 'Get the full experience with thousands of questions, multiplayer games, and more!',
    checkoutCompleteTitle: 'Checkout Complete',
    checkoutCompleteMessage: 'Stripe is confirming your subscription. Premium access will refresh shortly.',
    checkoutCancelledTitle: 'Checkout Cancelled',
    checkoutCancelledMessage: 'No payment was completed. You can return to Premium when you are ready.',
    checkEmailTitle: 'Check Your Email 📧',
    checkEmailMessage: 'We\'ve sent a confirmation link to:\n\n{{email}}\n\nPlease check your inbox and spam folder, then click the link to activate your account.',
    emailSentTitle: 'Email Sent ✅',
    emailSentMessage: 'Check your inbox for the confirmation link.',
    emailSentBanner: 'Email sent! Check your inbox.',
    premiumRequiredTitle: 'Premium Required',
    premiumRequiredMessage: 'This category requires a premium subscription. Upgrade to unlock all {{count}} premium categories!',
    upgradeNow: 'Upgrade Now',
    categoryLockedTitle: 'Category Locked',
    categoryLockedMessage: 'Reach level {{level}} to unlock "{{category}}". You are currently level {{current}}.',
    referralLoadFailed: 'Failed to load referral information',
    referralLinkCopied: 'Referral link copied to clipboard',
    referralCodeCopied: 'Referral code copied to clipboard',
    shareFailed: 'Failed to share',
    shareMessageFailed: 'Failed to share message',
    shareEmailFailed: 'Failed to share email',
    comingSoonTitle: 'Coming Soon',
    socialSharingSoon: 'Social media sharing will be available soon!',
    purchaseLoginRequired: 'You must be logged in to purchase a subscription',
    purchaseFailedTitle: 'Purchase Failed',
    purchaseFailedMessage: 'Unable to complete purchase',
    purchaseError: 'An error occurred during purchase',
    restoreLoginRequired: 'You must be logged in to restore purchases',
    noPurchasesFound: 'No Purchases Found',
    noPurchasesMessage: 'No previous purchases were found to restore',
    restoreFailedTitle: 'Restore Failed',
    restoreFailedMessage: 'Unable to restore purchases',
    restoreError: 'An error occurred while restoring purchases',
    notAuthenticated: 'User is not authenticated.',
    avatarUpdateFailed: 'Failed to update avatar.',
    uploadErrorTitle: 'Upload Error',
    avatarUploadFailed: 'Failed to upload avatar.',
    planInfoMissingShort: 'Plan information is missing. Please try again.',
    startGameFailed: 'Failed to start game. Please try again.',
    scoreBreakdown: 'Your Score Breakdown:',
    leaderboardTitle: 'Leaderboard',
    previous: 'Previous',
    next: 'Next',
    back: 'Back',
    ready: 'Ready',
    beta: 'Beta',
    soon: 'Soon',
    shareDailyQuiz: 'Share Daily Quiz',
    logoAlt: 'Kingdom Bible Quiz App Logo',
    copiedTitle: 'Copied!',
    shareTextCopied: 'Share text copied to clipboard',
    loadingChallenge: 'Loading today\'s challenge...',
    questionNotFound: 'Question not found',
    questionOfTheDay: 'Question of the Day',
    groupChallenge: 'Group Challenge',
    explanation: 'Explanation',
    shareResult: 'Share Result',
    downloadFullApp: 'Download Full App',
    demoFamilyName: 'The Johnson Family',
    demoFriendsGroupName: 'Youth Group',
    errorTitle: 'Error',
    successTitle: 'Success',
    ok: 'OK',
    accept: 'Accept',
    decline: 'Decline',
    cancel: 'Cancel',
    done: 'Done',
    notNow: 'Not now',
    maybeLater: 'Maybe Later',
    tryAgain: 'Try Again',
    loadingQuestion: 'Loading question...',
    loadingQuiz: 'Loading quiz...',
    loadingPlans: 'Loading subscription plans...',
    checkingPermissions: 'Checking permissions...',
    accessDenied: 'Access denied',
    noLeaderboardData: 'No leaderboard data',
    createGroupTitle: 'Create Family or Friends Group',
    joinFriendsTitle: 'Join Friends by Invite Code',
    inviteCodePlaceholder: 'Enter invite code...',
    joinFriendsFailed: 'Failed to join friends group.',
    leaderboardJoinPrompt: 'Join or create a group to see the leaderboard!',
    pendingInvitations: 'Pending Invitations',
    hostBadgeHint: 'This player is the room host and can start the game.',
    youBadgeHint: 'This is you! Only you can see this badge.',
    noValidRoomId: 'No valid room ID.',
    userNotFoundSignIn: 'User not found. Please sign in again.',
    planInfoMissing: 'Current plan information is missing. Please try again.',
    billingPerkYearly1: 'One payment per year - less hassle',
    billingPerkYearly2: 'Lock in current price for full year',
    billingPerkMonthly1: 'More flexibility to change plans',
    billingPerkMonthly2: 'Smaller monthly payments',
    billingPerkMonthly3: 'Easy to budget monthly',
    gateUnlimited: 'Unlimited daily quizzes',
    gateFamilyPlay: 'Family play and shared experiences',
    gateFamilyGrowth: 'Family play and shared growth',
    gateInsights: 'Deeper insights and devotionals',
    gateFormats: 'All question formats unlocked',
    signInRequired: 'Sign In Required',
    signInToAccessPremium: 'Please sign in to access premium features.',
    premiumFeatureGroups: 'Create family & friend Bible study groups',
    premiumFeatureHost: 'Host family Bible quiz sessions',
    premiumFeatureTrack: 'Track scores & family progress',
    availableIn: 'Available In',
    plansLoadFailed: 'Failed to load subscription plans. Please try again.',
    userNotFoundTryAgain: 'User not found. Please try again.',
    subscriptionCanceled: 'Subscription Canceled',
    subscriptionCanceledMessage: 'Your subscription has been canceled and will end at the current period.',
    cancelFailed: 'Failed to cancel subscription. Please try again.',
    unexpectedError: 'An unexpected error occurred. Please try again.',
    previewMode: 'Preview Mode',
    secureCheckout: 'Secure hosted Stripe Checkout',
    noCardDetails: 'No card details are entered in the app',
    currentSubscription: 'Current Subscription',
    termsOfUse: 'Terms of Use (EULA)',
    privacyPolicy: 'Privacy Policy',
    cancelPlan: 'Cancel Plan',
    mostPopular: 'MOST POPULAR',
    currentPlanBadge: 'CURRENT PLAN',
    preview: 'Preview',
    planLimits: 'Plan Limits:',
    planMembers: 'Up to {{count}} members',
    planMembersUnlimited: 'Unlimited members',
    selected: 'Selected ✓',
    selectPlan: 'Select Plan',
    featUnlimitedQuiz: '30,000+ questions with unlimited daily access',
    featAdFree: 'Ad-free experience',
    featHistory: 'Unlimited quiz history',
    featFormats: '5 different question formats (MCQ, True/False, Fill Blank, Ordering)',
    featLanguages: '10 languages available (more coming soon)',
    featMpCreate: 'Create multiplayer quiz rooms',
    featMpJoin: 'Join multiplayer quiz rooms',
    featFamilyAnalytics: 'Family progress tracking',
    featTeam: 'Invite up to {{count}} family members',
    featPacks: 'Premium quiz packs',
    signInFailed: 'Sign In Failed',
    signInFailedMessage: 'Could not complete sign in. Please try again.',
    signInError: 'Sign In Error',
    quizUnavailable: 'Quiz Unavailable',
    quizLinkInvalid: 'This quiz link is invalid or has expired.',
    navigationError: 'Navigation Error',
    openQuizFailed: 'Failed to open the quiz. Please try again.',
    invalidLink: 'Invalid Link',
    roomInviteInvalid: 'This room invitation link is invalid or expired.',
    openRoomFailed: 'Failed to open this room invitation. Please try again.',
    eventInviteInvalid: 'This event invitation link is invalid or expired.',
    eventLinkUnavailable: 'Event Link Unavailable',
    eventLinksUnsupported: 'Live event links are no longer supported in this app.',
    referralInvalid: 'This referral link is invalid.',
    alreadyRegistered: 'Already Registered',
    alreadyRegisteredMessage: 'You already have an account! Share this app with friends who haven\'t joined yet.',
    joinKbqTitle: 'Join Kingdom Bible Quiz!',
    joinKbqMessage: 'You\'ve been invited to join the ultimate Bible quiz app. Create your account to get started!',
    signUp: 'Sign Up',
    signupNavFailed: 'Failed to navigate to signup. Please try again.',
    exploredAll: 'Your family has explored {{count}} questions',
    exploredWeek: 'Your family has explored {{count}} questions this week',
    exploredMonth: 'Your family has explored {{count}} questions this month',
    filterWeek: 'This Week',
    filterMonth: 'This Month',
    filterAll: 'All Time',
    entryStats: '{{questions}} questions explored · {{quizzes}} quizzes',
    readyToStart: 'Ready to start!',
    statQuizzesTogether: 'Quizzes\nTogether',
    statQuestionsExplored: 'Questions\nExplored',
    statMembersActive: 'Members\nActive',
  },
  fr: {
    successBang: 'Succès !',
    great: 'Parfait !',
    billingUpdatedTitle: 'Facturation mise à jour !',
    billingSwitchedAnnual: 'Votre facturation est passée au paiement annuel. Vous économisez désormais {{percent}} % par an !',
    billingSwitchedMonthly: 'Votre facturation est passée au paiement mensuel. Votre prochain paiement sera mensuel.',
    billingChangeFailedTitle: 'Échec du changement de facturation',
    billingChangeFailedMessage: 'Impossible de modifier votre cycle de facturation. Veuillez réessayer.',
    planUpgraded: 'Votre abonnement est passé à {{plan}}. Vos nouvelles fonctionnalités sont actives !',
    planDowngraded: 'Votre abonnement est passé à {{plan}}. Vos nouvelles fonctionnalités sont actives !',
    planChanged: 'Votre abonnement est passé à {{plan}}. Vos nouvelles fonctionnalités sont actives !',
    planChangeFailedTitle: 'Échec du changement de forfait',
    planChangeFailedMessage: 'Impossible de modifier votre forfait. Veuillez réessayer.',
    subscriptionActivated: 'Votre abonnement est activé. Merci !',
    purchasesRestoredTitle: 'Achats restaurés',
    purchasesRestoredMessage: '{{count}} abonnement(s) restauré(s) avec succès',
    stripeSignInMessage: 'Connectez-vous ou créez un compte avant de lancer le paiement Stripe. Votre progression d\'invité pourra être transférée après la connexion.',
    previewSuccess: 'Abonnement simulé avec succès ! En mode réel, le paiement serait traité.',
    welcomeSubscription: 'Bienvenue dans votre nouvel abonnement ! Vos fonctionnalités premium sont actives.',
    processSubscriptionFailed: 'Impossible de traiter l\'abonnement. Veuillez réessayer.',
    startGameFailedTitle: 'Échec du lancement de la partie',
    joinRoomFailed: 'Impossible de rejoindre le salon. Veuillez réessayer.',
    joinRoomFailedWithReason: 'Impossible de rejoindre le salon : {{message}}',
    unknownError: 'Erreur inconnue',
    sharedSuccessTitle: 'Partagé avec succès !',
    sharedSuccessMessage: 'Votre quiz a été partagé via {{platform}}. Merci de diffuser la connaissance biblique !',
    shareAnother: 'Partager un autre',
    sharingFailedTitle: 'Échec du partage',
    sharingFailedMessage: 'Impossible de partager via {{platform}}. Veuillez réessayer.',
    sharingErrorTitle: 'Erreur de partage',
    sharingErrorMessage: 'Une erreur s\'est produite lors du partage vers {{platform}}. Veuillez réessayer.',
    platformSharingTitle: 'Partage {{platform}}',
    soonInstagram: 'Le partage Instagram ouvrira l\'application Instagram avec un contenu prérempli. Cette fonctionnalité arrive bientôt !',
    soonTikTok: 'Le partage TikTok créera un contenu vidéo attrayant à partir de votre question de quiz. Cette fonctionnalité arrive bientôt avec des modèles vidéo interactifs !',
    soonSnapchat: 'Le partage Snapchat créera des stories visuelles à partir de vos questions de quiz. Cette fonctionnalité arrive bientôt !',
    soonYouTube: 'Le partage YouTube vous permettra de publier du contenu de quiz dans votre onglet communauté ou vos descriptions de vidéos. Cette fonctionnalité arrive bientôt !',
    linkCopiedTitle: 'Lien copié !',
    linkCopiedMessage: 'Le lien du quiz a été copié dans le presse-papiers. Vous pouvez le coller où vous voulez.',
    shareToSlack: 'Partager sur Slack',
    shareToTeams: 'Partager sur Microsoft Teams',
    shareToDiscord: 'Partager sur Discord',
    pasteSlack: 'Contenu copié ! Ouvrez Slack et collez-le dans le canal ou le message privé de votre choix.',
    pasteTeams: 'Contenu copié ! Ouvrez Microsoft Teams et collez-le dans la conversation ou le canal de votre choix.',
    pasteDiscord: 'Contenu copié ! Ouvrez Discord et collez-le dans le serveur ou le message privé de votre choix.',
    downloadAppTitle: 'Télécharger Kingdom Bible Quiz',
    downloadAppMessage: 'Profitez de l\'expérience complète avec des milliers de questions, des parties multijoueurs et plus encore !',
    checkoutCompleteTitle: 'Paiement terminé',
    checkoutCompleteMessage: 'Stripe confirme votre abonnement. L\'accès premium sera actualisé sous peu.',
    checkoutCancelledTitle: 'Paiement annulé',
    checkoutCancelledMessage: 'Aucun paiement n\'a été effectué. Vous pouvez revenir à Premium quand vous le souhaitez.',
    checkEmailTitle: 'Vérifiez votre e-mail 📧',
    checkEmailMessage: 'Nous avons envoyé un lien de confirmation à :\n\n{{email}}\n\nVérifiez votre boîte de réception et vos spams, puis cliquez sur le lien pour activer votre compte.',
    emailSentTitle: 'E-mail envoyé ✅',
    emailSentMessage: 'Consultez votre boîte de réception pour le lien de confirmation.',
    emailSentBanner: 'E-mail envoyé ! Consultez votre boîte de réception.',
    premiumRequiredTitle: 'Premium requis',
    premiumRequiredMessage: 'Cette catégorie nécessite un abonnement premium. Passez à Premium pour débloquer les {{count}} catégories premium !',
    upgradeNow: 'Passer à Premium',
    categoryLockedTitle: 'Catégorie verrouillée',
    categoryLockedMessage: 'Atteignez le niveau {{level}} pour débloquer « {{category}} ». Vous êtes actuellement au niveau {{current}}.',
    referralLoadFailed: 'Impossible de charger les informations de parrainage',
    referralLinkCopied: 'Lien de parrainage copié dans le presse-papiers',
    referralCodeCopied: 'Code de parrainage copié dans le presse-papiers',
    shareFailed: 'Échec du partage',
    shareMessageFailed: 'Impossible de partager le message',
    shareEmailFailed: 'Impossible de partager par e-mail',
    comingSoonTitle: 'Bientôt disponible',
    socialSharingSoon: 'Le partage sur les réseaux sociaux arrive bientôt !',
    purchaseLoginRequired: 'Vous devez être connecté pour souscrire un abonnement',
    purchaseFailedTitle: 'Échec de l\'achat',
    purchaseFailedMessage: 'Impossible de finaliser l\'achat',
    purchaseError: 'Une erreur s\'est produite pendant l\'achat',
    restoreLoginRequired: 'Vous devez être connecté pour restaurer vos achats',
    noPurchasesFound: 'Aucun achat trouvé',
    noPurchasesMessage: 'Aucun achat précédent à restaurer n\'a été trouvé',
    restoreFailedTitle: 'Échec de la restauration',
    restoreFailedMessage: 'Impossible de restaurer les achats',
    restoreError: 'Une erreur s\'est produite pendant la restauration des achats',
    notAuthenticated: 'L\'utilisateur n\'est pas authentifié.',
    avatarUpdateFailed: 'Impossible de mettre à jour l\'avatar.',
    uploadErrorTitle: 'Erreur d\'envoi',
    avatarUploadFailed: 'Impossible d\'envoyer l\'avatar.',
    planInfoMissingShort: 'Les informations du forfait sont manquantes. Veuillez réessayer.',
    startGameFailed: 'Impossible de lancer la partie. Veuillez réessayer.',
    scoreBreakdown: 'Détail de votre score :',
    leaderboardTitle: 'Classement',
    previous: 'Précédent',
    next: 'Suivant',
    back: 'Retour',
    ready: 'Prêt',
    beta: 'Bêta',
    soon: 'Bientôt',
    shareDailyQuiz: 'Partager le quiz du jour',
    logoAlt: 'Logo de l\'application Kingdom Bible Quiz',
    copiedTitle: 'Copié !',
    shareTextCopied: 'Texte de partage copié dans le presse-papiers',
    loadingChallenge: 'Chargement du défi du jour…',
    questionNotFound: 'Question introuvable',
    questionOfTheDay: 'Question du jour',
    groupChallenge: 'Défi de groupe',
    explanation: 'Explication',
    shareResult: 'Partager le résultat',
    downloadFullApp: 'Télécharger l\'application complète',
    demoFamilyName: 'La famille Johnson',
    demoFriendsGroupName: 'Groupe de jeunes',
    errorTitle: 'Erreur',
    successTitle: 'Succès',
    ok: 'OK',
    accept: 'Accepter',
    decline: 'Refuser',
    cancel: 'Annuler',
    done: 'Terminé',
    notNow: 'Pas maintenant',
    maybeLater: 'Peut-être plus tard',
    tryAgain: 'Réessayer',
    loadingQuestion: 'Chargement de la question…',
    loadingQuiz: 'Chargement du quiz…',
    loadingPlans: 'Chargement des abonnements…',
    checkingPermissions: 'Vérification des autorisations…',
    accessDenied: 'Accès refusé',
    noLeaderboardData: 'Aucune donnée de classement',
    createGroupTitle: 'Créer un groupe famille ou amis',
    joinFriendsTitle: 'Rejoindre un groupe d\'amis avec un code',
    inviteCodePlaceholder: 'Saisissez le code d\'invitation…',
    joinFriendsFailed: 'Impossible de rejoindre le groupe d\'amis.',
    leaderboardJoinPrompt: 'Rejoignez ou créez un groupe pour voir le classement !',
    pendingInvitations: 'Invitations en attente',
    hostBadgeHint: 'Ce joueur est l\'hôte du salon et peut lancer la partie.',
    youBadgeHint: 'C\'est vous ! Vous seul voyez ce badge.',
    noValidRoomId: 'Identifiant de salon invalide.',
    userNotFoundSignIn: 'Utilisateur introuvable. Veuillez vous reconnecter.',
    planInfoMissing: 'Les informations du forfait actuel sont manquantes. Veuillez réessayer.',
    billingPerkYearly1: 'Un seul paiement par an : moins de tracas',
    billingPerkYearly2: 'Gardez le prix actuel pendant toute l\'année',
    billingPerkMonthly1: 'Plus de flexibilité pour changer de forfait',
    billingPerkMonthly2: 'Des paiements mensuels plus petits',
    billingPerkMonthly3: 'Facile à budgétiser chaque mois',
    gateUnlimited: 'Quiz quotidiens illimités',
    gateFamilyPlay: 'Jeu en famille et expériences partagées',
    gateFamilyGrowth: 'Jeu en famille et croissance partagée',
    gateInsights: 'Aperçus plus profonds et méditations',
    gateFormats: 'Tous les formats de questions débloqués',
    signInRequired: 'Connexion requise',
    signInToAccessPremium: 'Connectez-vous pour accéder aux fonctionnalités premium.',
    premiumFeatureGroups: 'Créez des groupes d\'étude biblique en famille et entre amis',
    premiumFeatureHost: 'Animez des sessions de quiz biblique en famille',
    premiumFeatureTrack: 'Suivez les scores et la progression de la famille',
    availableIn: 'Disponible dans',
    plansLoadFailed: 'Impossible de charger les abonnements. Veuillez réessayer.',
    userNotFoundTryAgain: 'Utilisateur introuvable. Veuillez réessayer.',
    subscriptionCanceled: 'Abonnement annulé',
    subscriptionCanceledMessage: 'Votre abonnement a été annulé et prendra fin à la fin de la période en cours.',
    cancelFailed: 'Impossible d\'annuler l\'abonnement. Veuillez réessayer.',
    unexpectedError: 'Une erreur inattendue s\'est produite. Veuillez réessayer.',
    previewMode: 'Mode aperçu',
    secureCheckout: 'Paiement sécurisé hébergé par Stripe',
    noCardDetails: 'Aucune donnée de carte n\'est saisie dans l\'application',
    currentSubscription: 'Abonnement actuel',
    termsOfUse: 'Conditions d\'utilisation (CLUF)',
    privacyPolicy: 'Politique de confidentialité',
    cancelPlan: 'Annuler l\'abonnement',
    mostPopular: 'LE PLUS POPULAIRE',
    currentPlanBadge: 'FORFAIT ACTUEL',
    preview: 'Aperçu',
    planLimits: 'Limites du forfait :',
    planMembers: 'Jusqu\'à {{count}} membres',
    planMembersUnlimited: 'Membres illimités',
    selected: 'Sélectionné ✓',
    selectPlan: 'Choisir ce forfait',
    featUnlimitedQuiz: 'Plus de 30 000 questions en accès quotidien illimité',
    featAdFree: 'Expérience sans publicité',
    featHistory: 'Historique des quiz illimité',
    featFormats: '5 formats de questions différents (QCM, Vrai/Faux, Texte à trous, Classement)',
    featLanguages: '10 langues disponibles (d\'autres arrivent bientôt)',
    featMpCreate: 'Créez des salons de quiz multijoueur',
    featMpJoin: 'Rejoignez des salons de quiz multijoueur',
    featFamilyAnalytics: 'Suivi de la progression familiale',
    featTeam: 'Invitez jusqu\'à {{count}} membres de la famille',
    featPacks: 'Packs de quiz premium',
    signInFailed: 'Échec de la connexion',
    signInFailedMessage: 'Impossible de terminer la connexion. Veuillez réessayer.',
    signInError: 'Erreur de connexion',
    quizUnavailable: 'Quiz indisponible',
    quizLinkInvalid: 'Ce lien de quiz est invalide ou a expiré.',
    navigationError: 'Erreur de navigation',
    openQuizFailed: 'Impossible d\'ouvrir le quiz. Veuillez réessayer.',
    invalidLink: 'Lien invalide',
    roomInviteInvalid: 'Ce lien d\'invitation au salon est invalide ou a expiré.',
    openRoomFailed: 'Impossible d\'ouvrir cette invitation au salon. Veuillez réessayer.',
    eventInviteInvalid: 'Ce lien d\'invitation à l\'événement est invalide ou a expiré.',
    eventLinkUnavailable: 'Lien d\'événement indisponible',
    eventLinksUnsupported: 'Les liens d\'événements en direct ne sont plus pris en charge dans cette application.',
    referralInvalid: 'Ce lien de parrainage est invalide.',
    alreadyRegistered: 'Déjà inscrit',
    alreadyRegisteredMessage: 'Vous avez déjà un compte ! Partagez cette application avec des amis qui n\'ont pas encore rejoint.',
    joinKbqTitle: 'Rejoignez Kingdom Bible Quiz !',
    joinKbqMessage: 'Vous êtes invité à rejoindre l\'application de quiz biblique par excellence. Créez votre compte pour commencer !',
    signUp: 'S\'inscrire',
    signupNavFailed: 'Impossible d\'ouvrir l\'inscription. Veuillez réessayer.',
    exploredAll: 'Votre famille a exploré {{count}} questions',
    exploredWeek: 'Votre famille a exploré {{count}} questions cette semaine',
    exploredMonth: 'Votre famille a exploré {{count}} questions ce mois-ci',
    filterWeek: 'Cette semaine',
    filterMonth: 'Ce mois-ci',
    filterAll: 'Depuis toujours',
    entryStats: '{{questions}} questions explorées · {{quizzes}} quiz',
    readyToStart: 'Prêt à commencer !',
    statQuizzesTogether: 'Quiz\nensemble',
    statQuestionsExplored: 'Questions\nexplorées',
    statMembersActive: 'Membres\nactifs',
  },
  es: {
    successBang: '¡Éxito!',
    great: '¡Genial!',
    billingUpdatedTitle: '¡Facturación actualizada!',
    billingSwitchedAnnual: 'Tu facturación ahora es anual. ¡Ahora ahorras un {{percent}} % al año!',
    billingSwitchedMonthly: 'Tu facturación ahora es mensual. Tu próximo pago será mensual.',
    billingChangeFailedTitle: 'Error al cambiar la facturación',
    billingChangeFailedMessage: 'No se pudo cambiar tu ciclo de facturación. Inténtalo de nuevo.',
    planUpgraded: 'Tu suscripción se ha mejorado a {{plan}}. ¡Tus nuevas funciones ya están activas!',
    planDowngraded: 'Tu suscripción se ha cambiado a {{plan}}. ¡Tus nuevas funciones ya están activas!',
    planChanged: 'Tu suscripción se ha cambiado a {{plan}}. ¡Tus nuevas funciones ya están activas!',
    planChangeFailedTitle: 'Error al cambiar el plan',
    planChangeFailedMessage: 'No se pudo cambiar tu plan. Inténtalo de nuevo.',
    subscriptionActivated: 'Tu suscripción está activada. ¡Gracias!',
    purchasesRestoredTitle: 'Compras restauradas',
    purchasesRestoredMessage: 'Se restauraron {{count}} suscripción(es) correctamente',
    stripeSignInMessage: 'Inicia sesión o crea una cuenta antes de iniciar el pago con Stripe. Tu progreso como invitado podrá migrarse tras iniciar sesión.',
    previewSuccess: '¡Suscripción simulada correctamente! En modo real, se procesaría el pago.',
    welcomeSubscription: '¡Te damos la bienvenida a tu nueva suscripción! Tus funciones premium ya están activas.',
    processSubscriptionFailed: 'No se pudo procesar la suscripción. Inténtalo de nuevo.',
    startGameFailedTitle: 'No se pudo iniciar la partida',
    joinRoomFailed: 'No se pudo unir a la sala. Inténtalo de nuevo.',
    joinRoomFailedWithReason: 'No se pudo unir a la sala: {{message}}',
    unknownError: 'Error desconocido',
    sharedSuccessTitle: '¡Compartido correctamente!',
    sharedSuccessMessage: 'Tu quiz se compartió por {{platform}}. ¡Gracias por difundir el conocimiento bíblico!',
    shareAnother: 'Compartir otro',
    sharingFailedTitle: 'Error al compartir',
    sharingFailedMessage: 'No se pudo compartir por {{platform}}. Inténtalo de nuevo.',
    sharingErrorTitle: 'Error al compartir',
    sharingErrorMessage: 'Ocurrió un error al compartir en {{platform}}. Inténtalo de nuevo.',
    platformSharingTitle: 'Compartir en {{platform}}',
    soonInstagram: 'Compartir en Instagram abrirá la app de Instagram con contenido prellenado. ¡Esta función llegará pronto!',
    soonTikTok: 'Compartir en TikTok creará contenido en video atractivo a partir de tu pregunta. ¡Esta función llegará pronto con plantillas de video interactivas!',
    soonSnapchat: 'Compartir en Snapchat creará historias visuales a partir de tus preguntas. ¡Esta función llegará pronto!',
    soonYouTube: 'Compartir en YouTube te permitirá publicar contenido del quiz en tu pestaña de comunidad o en las descripciones de tus videos. ¡Esta función llegará pronto!',
    linkCopiedTitle: '¡Enlace copiado!',
    linkCopiedMessage: 'El enlace del quiz se copió al portapapeles. Ahora puedes pegarlo donde quieras compartirlo.',
    shareToSlack: 'Compartir en Slack',
    shareToTeams: 'Compartir en Microsoft Teams',
    shareToDiscord: 'Compartir en Discord',
    pasteSlack: '¡Contenido copiado! Abre Slack y pégalo en el canal o mensaje directo que quieras.',
    pasteTeams: '¡Contenido copiado! Abre Microsoft Teams y pégalo en el chat o canal que quieras.',
    pasteDiscord: '¡Contenido copiado! Abre Discord y pégalo en el servidor o mensaje directo que quieras.',
    downloadAppTitle: 'Descargar Kingdom Bible Quiz',
    downloadAppMessage: '¡Disfruta la experiencia completa con miles de preguntas, juegos multijugador y más!',
    checkoutCompleteTitle: 'Pago completado',
    checkoutCompleteMessage: 'Stripe está confirmando tu suscripción. El acceso premium se actualizará en breve.',
    checkoutCancelledTitle: 'Pago cancelado',
    checkoutCancelledMessage: 'No se completó ningún pago. Puedes volver a Premium cuando quieras.',
    checkEmailTitle: 'Revisa tu correo 📧',
    checkEmailMessage: 'Hemos enviado un enlace de confirmación a:\n\n{{email}}\n\nRevisa tu bandeja de entrada y la carpeta de spam, y pulsa el enlace para activar tu cuenta.',
    emailSentTitle: 'Correo enviado ✅',
    emailSentMessage: 'Revisa tu bandeja de entrada para encontrar el enlace de confirmación.',
    emailSentBanner: '¡Correo enviado! Revisa tu bandeja de entrada.',
    premiumRequiredTitle: 'Se requiere Premium',
    premiumRequiredMessage: 'Esta categoría requiere una suscripción premium. ¡Mejora tu plan para desbloquear las {{count}} categorías premium!',
    upgradeNow: 'Mejorar ahora',
    categoryLockedTitle: 'Categoría bloqueada',
    categoryLockedMessage: 'Alcanza el nivel {{level}} para desbloquear «{{category}}». Ahora estás en el nivel {{current}}.',
    referralLoadFailed: 'No se pudo cargar la información de referidos',
    referralLinkCopied: 'Enlace de referido copiado al portapapeles',
    referralCodeCopied: 'Código de referido copiado al portapapeles',
    shareFailed: 'No se pudo compartir',
    shareMessageFailed: 'No se pudo compartir el mensaje',
    shareEmailFailed: 'No se pudo compartir por correo',
    comingSoonTitle: 'Próximamente',
    socialSharingSoon: '¡Compartir en redes sociales estará disponible pronto!',
    purchaseLoginRequired: 'Debes iniciar sesión para comprar una suscripción',
    purchaseFailedTitle: 'Compra fallida',
    purchaseFailedMessage: 'No se pudo completar la compra',
    purchaseError: 'Ocurrió un error durante la compra',
    restoreLoginRequired: 'Debes iniciar sesión para restaurar compras',
    noPurchasesFound: 'No se encontraron compras',
    noPurchasesMessage: 'No se encontraron compras anteriores para restaurar',
    restoreFailedTitle: 'Error al restaurar',
    restoreFailedMessage: 'No se pudieron restaurar las compras',
    restoreError: 'Ocurrió un error al restaurar las compras',
    notAuthenticated: 'El usuario no está autenticado.',
    avatarUpdateFailed: 'No se pudo actualizar el avatar.',
    uploadErrorTitle: 'Error de carga',
    avatarUploadFailed: 'No se pudo subir el avatar.',
    planInfoMissingShort: 'Falta la información del plan. Inténtalo de nuevo.',
    startGameFailed: 'No se pudo iniciar la partida. Inténtalo de nuevo.',
    scoreBreakdown: 'Desglose de tu puntuación:',
    leaderboardTitle: 'Clasificación',
    previous: 'Anterior',
    next: 'Siguiente',
    back: 'Volver',
    ready: 'Listo',
    beta: 'Beta',
    soon: 'Pronto',
    shareDailyQuiz: 'Compartir el quiz diario',
    logoAlt: 'Logotipo de la app Kingdom Bible Quiz',
    copiedTitle: '¡Copiado!',
    shareTextCopied: 'Texto para compartir copiado al portapapeles',
    loadingChallenge: 'Cargando el reto de hoy…',
    questionNotFound: 'Pregunta no encontrada',
    questionOfTheDay: 'Pregunta del día',
    groupChallenge: 'Reto grupal',
    explanation: 'Explicación',
    shareResult: 'Compartir resultado',
    downloadFullApp: 'Descargar la app completa',
    demoFamilyName: 'La familia Johnson',
    demoFriendsGroupName: 'Grupo de jóvenes',
    errorTitle: 'Error',
    successTitle: 'Éxito',
    ok: 'OK',
    accept: 'Aceptar',
    decline: 'Rechazar',
    cancel: 'Cancelar',
    done: 'Hecho',
    notNow: 'Ahora no',
    maybeLater: 'Quizás más tarde',
    tryAgain: 'Intentar de nuevo',
    loadingQuestion: 'Cargando pregunta…',
    loadingQuiz: 'Cargando quiz…',
    loadingPlans: 'Cargando planes de suscripción…',
    checkingPermissions: 'Comprobando permisos…',
    accessDenied: 'Acceso denegado',
    noLeaderboardData: 'No hay datos de clasificación',
    createGroupTitle: 'Crear grupo de familia o amigos',
    joinFriendsTitle: 'Unirse a amigos con código de invitación',
    inviteCodePlaceholder: 'Introduce el código de invitación…',
    joinFriendsFailed: 'No se pudo unir al grupo de amigos.',
    leaderboardJoinPrompt: '¡Únete o crea un grupo para ver la clasificación!',
    pendingInvitations: 'Invitaciones pendientes',
    hostBadgeHint: 'Este jugador es el anfitrión de la sala y puede iniciar la partida.',
    youBadgeHint: '¡Eres tú! Solo tú ves esta insignia.',
    noValidRoomId: 'ID de sala no válido.',
    userNotFoundSignIn: 'Usuario no encontrado. Inicia sesión de nuevo.',
    planInfoMissing: 'Falta la información del plan actual. Inténtalo de nuevo.',
    billingPerkYearly1: 'Un pago al año: menos complicaciones',
    billingPerkYearly2: 'Fija el precio actual durante todo el año',
    billingPerkMonthly1: 'Más flexibilidad para cambiar de plan',
    billingPerkMonthly2: 'Pagos mensuales más pequeños',
    billingPerkMonthly3: 'Fácil de presupuestar cada mes',
    gateUnlimited: 'Quizzes diarios ilimitados',
    gateFamilyPlay: 'Juego en familia y experiencias compartidas',
    gateFamilyGrowth: 'Juego en familia y crecimiento compartido',
    gateInsights: 'Reflexiones más profundas y devocionales',
    gateFormats: 'Todos los formatos de preguntas desbloqueados',
    signInRequired: 'Se requiere iniciar sesión',
    signInToAccessPremium: 'Inicia sesión para acceder a las funciones premium.',
    premiumFeatureGroups: 'Crea grupos de estudio bíblico con familia y amigos',
    premiumFeatureHost: 'Organiza sesiones de quiz bíblico en familia',
    premiumFeatureTrack: 'Sigue las puntuaciones y el progreso familiar',
    availableIn: 'Disponible en',
    plansLoadFailed: 'No se pudieron cargar los planes de suscripción. Inténtalo de nuevo.',
    userNotFoundTryAgain: 'Usuario no encontrado. Inténtalo de nuevo.',
    subscriptionCanceled: 'Suscripción cancelada',
    subscriptionCanceledMessage: 'Tu suscripción se ha cancelado y terminará al final del período actual.',
    cancelFailed: 'No se pudo cancelar la suscripción. Inténtalo de nuevo.',
    unexpectedError: 'Ocurrió un error inesperado. Inténtalo de nuevo.',
    previewMode: 'Modo de vista previa',
    secureCheckout: 'Pago seguro alojado en Stripe',
    noCardDetails: 'No se introducen datos de tarjeta en la app',
    currentSubscription: 'Suscripción actual',
    termsOfUse: 'Términos de uso (EULA)',
    privacyPolicy: 'Política de privacidad',
    cancelPlan: 'Cancelar plan',
    mostPopular: 'MÁS POPULAR',
    currentPlanBadge: 'PLAN ACTUAL',
    preview: 'Vista previa',
    planLimits: 'Límites del plan:',
    planMembers: 'Hasta {{count}} miembros',
    planMembersUnlimited: 'Miembros ilimitados',
    selected: 'Seleccionado ✓',
    selectPlan: 'Seleccionar plan',
    featUnlimitedQuiz: 'Más de 30 000 preguntas con acceso diario ilimitado',
    featAdFree: 'Experiencia sin anuncios',
    featHistory: 'Historial de quizzes ilimitado',
    featFormats: '5 formatos de preguntas diferentes (opción múltiple, verdadero/falso, completar, ordenar)',
    featLanguages: '10 idiomas disponibles (más próximamente)',
    featMpCreate: 'Crea salas de quiz multijugador',
    featMpJoin: 'Únete a salas de quiz multijugador',
    featFamilyAnalytics: 'Seguimiento del progreso familiar',
    featTeam: 'Invita hasta {{count}} miembros de la familia',
    featPacks: 'Paquetes de quizzes premium',
    signInFailed: 'Error al iniciar sesión',
    signInFailedMessage: 'No se pudo completar el inicio de sesión. Inténtalo de nuevo.',
    signInError: 'Error de inicio de sesión',
    quizUnavailable: 'Quiz no disponible',
    quizLinkInvalid: 'Este enlace de quiz no es válido o ha caducado.',
    navigationError: 'Error de navegación',
    openQuizFailed: 'No se pudo abrir el quiz. Inténtalo de nuevo.',
    invalidLink: 'Enlace no válido',
    roomInviteInvalid: 'Este enlace de invitación a la sala no es válido o ha caducado.',
    openRoomFailed: 'No se pudo abrir esta invitación a la sala. Inténtalo de nuevo.',
    eventInviteInvalid: 'Este enlace de invitación al evento no es válido o ha caducado.',
    eventLinkUnavailable: 'Enlace de evento no disponible',
    eventLinksUnsupported: 'Los enlaces de eventos en vivo ya no son compatibles con esta app.',
    referralInvalid: 'Este enlace de referido no es válido.',
    alreadyRegistered: 'Ya registrado',
    alreadyRegisteredMessage: '¡Ya tienes una cuenta! Comparte esta app con amigos que aún no se han unido.',
    joinKbqTitle: '¡Únete a Kingdom Bible Quiz!',
    joinKbqMessage: '¡Te han invitado a la mejor app de quiz bíblico! Crea tu cuenta para empezar.',
    signUp: 'Registrarse',
    signupNavFailed: 'No se pudo abrir el registro. Inténtalo de nuevo.',
    exploredAll: 'Tu familia ha explorado {{count}} preguntas',
    exploredWeek: 'Tu familia ha explorado {{count}} preguntas esta semana',
    exploredMonth: 'Tu familia ha explorado {{count}} preguntas este mes',
    filterWeek: 'Esta semana',
    filterMonth: 'Este mes',
    filterAll: 'Todo el tiempo',
    entryStats: '{{questions}} preguntas exploradas · {{quizzes}} quizzes',
    readyToStart: '¡Listo para empezar!',
    statQuizzesTogether: 'Quizzes\njuntos',
    statQuestionsExplored: 'Preguntas\nexploradas',
    statMembersActive: 'Miembros\nactivos',
  },
  de: {
    successBang: 'Erfolg!',
    great: 'Super!',
    billingUpdatedTitle: 'Abrechnung aktualisiert!',
    billingSwitchedAnnual: 'Deine Abrechnung wurde auf jährliche Zahlung umgestellt. Du sparst jetzt {{percent}} % pro Jahr!',
    billingSwitchedMonthly: 'Deine Abrechnung wurde auf monatliche Zahlung umgestellt. Deine nächste Zahlung erfolgt monatlich.',
    billingChangeFailedTitle: 'Abrechnungsänderung fehlgeschlagen',
    billingChangeFailedMessage: 'Dein Abrechnungszeitraum konnte nicht geändert werden. Bitte versuche es erneut.',
    planUpgraded: 'Dein Abo wurde auf {{plan}} aktualisiert. Deine neuen Funktionen sind jetzt aktiv!',
    planDowngraded: 'Dein Abo wurde auf {{plan}} herabgestuft. Deine neuen Funktionen sind jetzt aktiv!',
    planChanged: 'Dein Abo wurde auf {{plan}} geändert. Deine neuen Funktionen sind jetzt aktiv!',
    planChangeFailedTitle: 'Planwechsel fehlgeschlagen',
    planChangeFailedMessage: 'Dein Plan konnte nicht geändert werden. Bitte versuche es erneut.',
    subscriptionActivated: 'Dein Abo wurde aktiviert. Vielen Dank!',
    purchasesRestoredTitle: 'Käufe wiederhergestellt',
    purchasesRestoredMessage: '{{count}} Abo(s) erfolgreich wiederhergestellt',
    stripeSignInMessage: 'Melde dich an oder erstelle ein Konto, bevor du den Stripe-Checkout startest. Dein Gastfortschritt kann nach der Anmeldung übernommen werden.',
    previewSuccess: 'Abo erfolgreich simuliert! Im Live-Modus würde die Zahlung verarbeitet.',
    welcomeSubscription: 'Willkommen bei deinem neuen Abo! Deine Premium-Funktionen sind jetzt aktiv.',
    processSubscriptionFailed: 'Abo konnte nicht verarbeitet werden. Bitte versuche es erneut.',
    startGameFailedTitle: 'Spielstart fehlgeschlagen',
    joinRoomFailed: 'Beitritt zum Raum fehlgeschlagen. Bitte versuche es erneut.',
    joinRoomFailedWithReason: 'Beitritt zum Raum fehlgeschlagen: {{message}}',
    unknownError: 'Unbekannter Fehler',
    sharedSuccessTitle: 'Erfolgreich geteilt!',
    sharedSuccessMessage: 'Dein Quiz wurde über {{platform}} geteilt. Danke, dass du biblisches Wissen verbreitest!',
    shareAnother: 'Weiteres teilen',
    sharingFailedTitle: 'Teilen fehlgeschlagen',
    sharingFailedMessage: 'Teilen über {{platform}} nicht möglich. Bitte versuche es erneut.',
    sharingErrorTitle: 'Fehler beim Teilen',
    sharingErrorMessage: 'Beim Teilen über {{platform}} ist ein Fehler aufgetreten. Bitte versuche es erneut.',
    platformSharingTitle: '{{platform}}-Teilen',
    soonInstagram: 'Beim Teilen auf Instagram öffnet sich die Instagram-App mit vorbereitetem Inhalt. Diese Funktion kommt bald!',
    soonTikTok: 'Beim Teilen auf TikTok entsteht aus deiner Quizfrage ein ansprechendes Video. Diese Funktion kommt bald mit interaktiven Videovorlagen!',
    soonSnapchat: 'Beim Teilen auf Snapchat entstehen aus deinen Quizfragen visuelle Stories. Diese Funktion kommt bald!',
    soonYouTube: 'Mit dem Teilen auf YouTube kannst du Quiz-Inhalte in deinem Community-Tab oder in Videobeschreibungen posten. Diese Funktion kommt bald!',
    linkCopiedTitle: 'Link kopiert!',
    linkCopiedMessage: 'Der Quiz-Link wurde in die Zwischenablage kopiert. Du kannst ihn jetzt überall einfügen.',
    shareToSlack: 'Auf Slack teilen',
    shareToTeams: 'In Microsoft Teams teilen',
    shareToDiscord: 'Auf Discord teilen',
    pasteSlack: 'Inhalt kopiert! Öffne Slack und füge ihn in den gewünschten Kanal oder die Direktnachricht ein.',
    pasteTeams: 'Inhalt kopiert! Öffne Microsoft Teams und füge ihn in den gewünschten Chat oder Kanal ein.',
    pasteDiscord: 'Inhalt kopiert! Öffne Discord und füge ihn auf dem gewünschten Server oder in der Direktnachricht ein.',
    downloadAppTitle: 'Kingdom Bible Quiz herunterladen',
    downloadAppMessage: 'Erlebe das volle Programm mit Tausenden Fragen, Mehrspieler-Spielen und mehr!',
    checkoutCompleteTitle: 'Checkout abgeschlossen',
    checkoutCompleteMessage: 'Stripe bestätigt dein Abo. Der Premium-Zugang wird in Kürze aktualisiert.',
    checkoutCancelledTitle: 'Checkout abgebrochen',
    checkoutCancelledMessage: 'Es wurde keine Zahlung abgeschlossen. Du kannst jederzeit zu Premium zurückkehren.',
    checkEmailTitle: 'Prüfe deine E-Mails 📧',
    checkEmailMessage: 'Wir haben einen Bestätigungslink gesendet an:\n\n{{email}}\n\nPrüfe deinen Posteingang und den Spam-Ordner und klicke auf den Link, um dein Konto zu aktivieren.',
    emailSentTitle: 'E-Mail gesendet ✅',
    emailSentMessage: 'Prüfe deinen Posteingang auf den Bestätigungslink.',
    emailSentBanner: 'E-Mail gesendet! Prüfe deinen Posteingang.',
    premiumRequiredTitle: 'Premium erforderlich',
    premiumRequiredMessage: 'Diese Kategorie erfordert ein Premium-Abo. Upgrade, um alle {{count}} Premium-Kategorien freizuschalten!',
    upgradeNow: 'Jetzt upgraden',
    categoryLockedTitle: 'Kategorie gesperrt',
    categoryLockedMessage: 'Erreiche Level {{level}}, um „{{category}}“ freizuschalten. Du bist aktuell auf Level {{current}}.',
    referralLoadFailed: 'Empfehlungsinformationen konnten nicht geladen werden',
    referralLinkCopied: 'Empfehlungslink in die Zwischenablage kopiert',
    referralCodeCopied: 'Empfehlungscode in die Zwischenablage kopiert',
    shareFailed: 'Teilen fehlgeschlagen',
    shareMessageFailed: 'Nachricht konnte nicht geteilt werden',
    shareEmailFailed: 'E-Mail konnte nicht geteilt werden',
    comingSoonTitle: 'Demnächst verfügbar',
    socialSharingSoon: 'Das Teilen in sozialen Netzwerken ist bald verfügbar!',
    purchaseLoginRequired: 'Du musst angemeldet sein, um ein Abo abzuschließen',
    purchaseFailedTitle: 'Kauf fehlgeschlagen',
    purchaseFailedMessage: 'Kauf konnte nicht abgeschlossen werden',
    purchaseError: 'Beim Kauf ist ein Fehler aufgetreten',
    restoreLoginRequired: 'Du musst angemeldet sein, um Käufe wiederherzustellen',
    noPurchasesFound: 'Keine Käufe gefunden',
    noPurchasesMessage: 'Es wurden keine früheren Käufe zum Wiederherstellen gefunden',
    restoreFailedTitle: 'Wiederherstellung fehlgeschlagen',
    restoreFailedMessage: 'Käufe konnten nicht wiederhergestellt werden',
    restoreError: 'Beim Wiederherstellen der Käufe ist ein Fehler aufgetreten',
    notAuthenticated: 'Der Benutzer ist nicht angemeldet.',
    avatarUpdateFailed: 'Avatar konnte nicht aktualisiert werden.',
    uploadErrorTitle: 'Upload-Fehler',
    avatarUploadFailed: 'Avatar konnte nicht hochgeladen werden.',
    planInfoMissingShort: 'Die Planinformationen fehlen. Bitte versuche es erneut.',
    startGameFailed: 'Spiel konnte nicht gestartet werden. Bitte versuche es erneut.',
    scoreBreakdown: 'Deine Punkteaufschlüsselung:',
    leaderboardTitle: 'Rangliste',
    previous: 'Zurück',
    next: 'Weiter',
    back: 'Zurück',
    ready: 'Bereit',
    beta: 'Beta',
    soon: 'Bald',
    shareDailyQuiz: 'Tagesquiz teilen',
    logoAlt: 'Kingdom-Bible-Quiz-App-Logo',
    copiedTitle: 'Kopiert!',
    shareTextCopied: 'Teilen-Text in die Zwischenablage kopiert',
    loadingChallenge: 'Heutige Herausforderung wird geladen…',
    questionNotFound: 'Frage nicht gefunden',
    questionOfTheDay: 'Frage des Tages',
    groupChallenge: 'Gruppen-Herausforderung',
    explanation: 'Erklärung',
    shareResult: 'Ergebnis teilen',
    downloadFullApp: 'Vollständige App herunterladen',
    demoFamilyName: 'Familie Johnson',
    demoFriendsGroupName: 'Jugendgruppe',
    errorTitle: 'Fehler',
    successTitle: 'Erfolg',
    ok: 'OK',
    accept: 'Annehmen',
    decline: 'Ablehnen',
    cancel: 'Abbrechen',
    done: 'Fertig',
    notNow: 'Jetzt nicht',
    maybeLater: 'Vielleicht später',
    tryAgain: 'Erneut versuchen',
    loadingQuestion: 'Frage wird geladen…',
    loadingQuiz: 'Quiz wird geladen…',
    loadingPlans: 'Abo-Pläne werden geladen…',
    checkingPermissions: 'Berechtigungen werden geprüft…',
    accessDenied: 'Zugriff verweigert',
    noLeaderboardData: 'Keine Ranglistendaten',
    createGroupTitle: 'Familien- oder Freundesgruppe erstellen',
    joinFriendsTitle: 'Freunden per Einladungscode beitreten',
    inviteCodePlaceholder: 'Einladungscode eingeben…',
    joinFriendsFailed: 'Beitritt zur Freundesgruppe fehlgeschlagen.',
    leaderboardJoinPrompt: 'Tritt einer Gruppe bei oder erstelle eine, um die Rangliste zu sehen!',
    pendingInvitations: 'Ausstehende Einladungen',
    hostBadgeHint: 'Dieser Spieler ist der Gastgeber des Raums und kann das Spiel starten.',
    youBadgeHint: 'Das bist du! Nur du siehst dieses Abzeichen.',
    noValidRoomId: 'Keine gültige Raum-ID.',
    userNotFoundSignIn: 'Benutzer nicht gefunden. Bitte melde dich erneut an.',
    planInfoMissing: 'Die Informationen zum aktuellen Plan fehlen. Bitte versuche es erneut.',
    billingPerkYearly1: 'Eine Zahlung pro Jahr – weniger Aufwand',
    billingPerkYearly2: 'Sichere dir den aktuellen Preis für ein ganzes Jahr',
    billingPerkMonthly1: 'Mehr Flexibilität beim Planwechsel',
    billingPerkMonthly2: 'Kleinere monatliche Zahlungen',
    billingPerkMonthly3: 'Einfach monatlich zu planen',
    gateUnlimited: 'Unbegrenzte tägliche Quizze',
    gateFamilyPlay: 'Spielen mit der Familie und gemeinsame Erlebnisse',
    gateFamilyGrowth: 'Spielen mit der Familie und gemeinsames Wachsen',
    gateInsights: 'Tiefere Einblicke und Andachten',
    gateFormats: 'Alle Fragetypen freigeschaltet',
    signInRequired: 'Anmeldung erforderlich',
    signInToAccessPremium: 'Bitte melde dich an, um Premium-Funktionen zu nutzen.',
    premiumFeatureGroups: 'Erstelle Bibelstudiengruppen mit Familie und Freunden',
    premiumFeatureHost: 'Leite Bibelquiz-Runden für die Familie',
    premiumFeatureTrack: 'Verfolge Punktzahlen und den Familienfortschritt',
    availableIn: 'Verfügbar in',
    plansLoadFailed: 'Abo-Pläne konnten nicht geladen werden. Bitte versuche es erneut.',
    userNotFoundTryAgain: 'Benutzer nicht gefunden. Bitte versuche es erneut.',
    subscriptionCanceled: 'Abo gekündigt',
    subscriptionCanceledMessage: 'Dein Abo wurde gekündigt und endet zum Ende des aktuellen Zeitraums.',
    cancelFailed: 'Abo konnte nicht gekündigt werden. Bitte versuche es erneut.',
    unexpectedError: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut.',
    previewMode: 'Vorschaumodus',
    secureCheckout: 'Sicherer, von Stripe gehosteter Checkout',
    noCardDetails: 'In der App werden keine Kartendaten eingegeben',
    currentSubscription: 'Aktuelles Abo',
    termsOfUse: 'Nutzungsbedingungen (EULA)',
    privacyPolicy: 'Datenschutzerklärung',
    cancelPlan: 'Plan kündigen',
    mostPopular: 'AM BELIEBTESTEN',
    currentPlanBadge: 'AKTUELLER PLAN',
    preview: 'Vorschau',
    planLimits: 'Planlimits:',
    planMembers: 'Bis zu {{count}} Mitglieder',
    planMembersUnlimited: 'Unbegrenzt viele Mitglieder',
    selected: 'Ausgewählt ✓',
    selectPlan: 'Plan auswählen',
    featUnlimitedQuiz: 'Über 30.000 Fragen mit unbegrenztem täglichem Zugriff',
    featAdFree: 'Werbefreies Erlebnis',
    featHistory: 'Unbegrenzter Quizverlauf',
    featFormats: '5 verschiedene Fragetypen (Multiple Choice, Wahr/Falsch, Lückentext, Reihenfolge)',
    featLanguages: '10 Sprachen verfügbar (weitere folgen)',
    featMpCreate: 'Erstelle Mehrspieler-Quizräume',
    featMpJoin: 'Tritt Mehrspieler-Quizräumen bei',
    featFamilyAnalytics: 'Verfolgung des Familienfortschritts',
    featTeam: 'Lade bis zu {{count}} Familienmitglieder ein',
    featPacks: 'Premium-Quizpakete',
    signInFailed: 'Anmeldung fehlgeschlagen',
    signInFailedMessage: 'Die Anmeldung konnte nicht abgeschlossen werden. Bitte versuche es erneut.',
    signInError: 'Anmeldefehler',
    quizUnavailable: 'Quiz nicht verfügbar',
    quizLinkInvalid: 'Dieser Quiz-Link ist ungültig oder abgelaufen.',
    navigationError: 'Navigationsfehler',
    openQuizFailed: 'Das Quiz konnte nicht geöffnet werden. Bitte versuche es erneut.',
    invalidLink: 'Ungültiger Link',
    roomInviteInvalid: 'Dieser Raumeinladungs-Link ist ungültig oder abgelaufen.',
    openRoomFailed: 'Die Raumeinladung konnte nicht geöffnet werden. Bitte versuche es erneut.',
    eventInviteInvalid: 'Dieser Event-Einladungslink ist ungültig oder abgelaufen.',
    eventLinkUnavailable: 'Event-Link nicht verfügbar',
    eventLinksUnsupported: 'Live-Event-Links werden in dieser App nicht mehr unterstützt.',
    referralInvalid: 'Dieser Empfehlungslink ist ungültig.',
    alreadyRegistered: 'Bereits registriert',
    alreadyRegisteredMessage: 'Du hast bereits ein Konto! Teile diese App mit Freunden, die noch nicht dabei sind.',
    joinKbqTitle: 'Mach mit bei Kingdom Bible Quiz!',
    joinKbqMessage: 'Du wurdest zur ultimativen Bibelquiz-App eingeladen. Erstelle dein Konto und leg los!',
    signUp: 'Registrieren',
    signupNavFailed: 'Die Registrierung konnte nicht geöffnet werden. Bitte versuche es erneut.',
    exploredAll: 'Deine Familie hat {{count}} Fragen erkundet',
    exploredWeek: 'Deine Familie hat diese Woche {{count}} Fragen erkundet',
    exploredMonth: 'Deine Familie hat diesen Monat {{count}} Fragen erkundet',
    filterWeek: 'Diese Woche',
    filterMonth: 'Diesen Monat',
    filterAll: 'Gesamt',
    entryStats: '{{questions}} Fragen erkundet · {{quizzes}} Quizze',
    readyToStart: 'Bereit zum Start!',
    statQuizzesTogether: 'Quizze\ngemeinsam',
    statQuestionsExplored: 'Fragen\nerkundet',
    statMembersActive: 'Aktive\nMitglieder',
  },
  pt: {
    successBang: 'Sucesso!',
    great: 'Ótimo!',
    billingUpdatedTitle: 'Cobrança atualizada!',
    billingSwitchedAnnual: 'Sua cobrança foi alterada para pagamentos anuais. Agora você economiza {{percent}}% por ano!',
    billingSwitchedMonthly: 'Sua cobrança foi alterada para pagamentos mensais. Seu próximo pagamento será mensal.',
    billingChangeFailedTitle: 'Falha ao alterar a cobrança',
    billingChangeFailedMessage: 'Não foi possível alterar seu ciclo de cobrança. Tente novamente.',
    planUpgraded: 'Sua assinatura foi atualizada para {{plan}}. Seus novos recursos já estão ativos!',
    planDowngraded: 'Sua assinatura foi alterada para {{plan}}. Seus novos recursos já estão ativos!',
    planChanged: 'Sua assinatura foi alterada para {{plan}}. Seus novos recursos já estão ativos!',
    planChangeFailedTitle: 'Falha ao alterar o plano',
    planChangeFailedMessage: 'Não foi possível alterar seu plano. Tente novamente.',
    subscriptionActivated: 'Sua assinatura foi ativada. Obrigado!',
    purchasesRestoredTitle: 'Compras restauradas',
    purchasesRestoredMessage: '{{count}} assinatura(s) restaurada(s) com sucesso',
    stripeSignInMessage: 'Entre ou crie uma conta antes de iniciar o checkout do Stripe. Seu progresso como convidado poderá ser migrado após o login.',
    previewSuccess: 'Assinatura simulada com sucesso! No modo real, o pagamento seria processado.',
    welcomeSubscription: 'Boas-vindas à sua nova assinatura! Seus recursos premium já estão ativos.',
    processSubscriptionFailed: 'Não foi possível processar a assinatura. Tente novamente.',
    startGameFailedTitle: 'Falha ao iniciar o jogo',
    joinRoomFailed: 'Falha ao entrar na sala. Tente novamente.',
    joinRoomFailedWithReason: 'Falha ao entrar na sala: {{message}}',
    unknownError: 'Erro desconhecido',
    sharedSuccessTitle: 'Compartilhado com sucesso!',
    sharedSuccessMessage: 'Seu quiz foi compartilhado via {{platform}}. Obrigado por espalhar o conhecimento bíblico!',
    shareAnother: 'Compartilhar outro',
    sharingFailedTitle: 'Falha ao compartilhar',
    sharingFailedMessage: 'Não foi possível compartilhar via {{platform}}. Tente novamente.',
    sharingErrorTitle: 'Erro ao compartilhar',
    sharingErrorMessage: 'Ocorreu um erro ao compartilhar no {{platform}}. Tente novamente.',
    platformSharingTitle: 'Compartilhar no {{platform}}',
    soonInstagram: 'Compartilhar no Instagram abrirá o app do Instagram com conteúdo preenchido. Este recurso chega em breve!',
    soonTikTok: 'Compartilhar no TikTok criará um vídeo envolvente a partir da sua pergunta. Este recurso chega em breve com modelos de vídeo interativos!',
    soonSnapchat: 'Compartilhar no Snapchat criará stories visuais a partir das suas perguntas. Este recurso chega em breve!',
    soonYouTube: 'Compartilhar no YouTube permitirá publicar conteúdo do quiz na aba Comunidade ou nas descrições dos vídeos. Este recurso chega em breve!',
    linkCopiedTitle: 'Link copiado!',
    linkCopiedMessage: 'O link do quiz foi copiado para a área de transferência. Agora você pode colá-lo onde quiser compartilhar.',
    shareToSlack: 'Compartilhar no Slack',
    shareToTeams: 'Compartilhar no Microsoft Teams',
    shareToDiscord: 'Compartilhar no Discord',
    pasteSlack: 'Conteúdo copiado! Abra o Slack e cole no canal ou mensagem direta que preferir.',
    pasteTeams: 'Conteúdo copiado! Abra o Microsoft Teams e cole no chat ou canal que preferir.',
    pasteDiscord: 'Conteúdo copiado! Abra o Discord e cole no servidor ou mensagem direta que preferir.',
    downloadAppTitle: 'Baixar o Kingdom Bible Quiz',
    downloadAppMessage: 'Aproveite a experiência completa com milhares de perguntas, jogos multijogador e muito mais!',
    checkoutCompleteTitle: 'Compra concluída',
    checkoutCompleteMessage: 'O Stripe está confirmando sua assinatura. O acesso premium será atualizado em breve.',
    checkoutCancelledTitle: 'Compra cancelada',
    checkoutCancelledMessage: 'Nenhum pagamento foi concluído. Você pode voltar ao Premium quando quiser.',
    checkEmailTitle: 'Verifique seu e-mail 📧',
    checkEmailMessage: 'Enviamos um link de confirmação para:\n\n{{email}}\n\nVerifique sua caixa de entrada e a pasta de spam e clique no link para ativar sua conta.',
    emailSentTitle: 'E-mail enviado ✅',
    emailSentMessage: 'Verifique sua caixa de entrada para ver o link de confirmação.',
    emailSentBanner: 'E-mail enviado! Verifique sua caixa de entrada.',
    premiumRequiredTitle: 'Premium necessário',
    premiumRequiredMessage: 'Esta categoria exige uma assinatura premium. Faça upgrade para desbloquear todas as {{count}} categorias premium!',
    upgradeNow: 'Fazer upgrade agora',
    categoryLockedTitle: 'Categoria bloqueada',
    categoryLockedMessage: 'Chegue ao nível {{level}} para desbloquear "{{category}}". Você está no nível {{current}}.',
    referralLoadFailed: 'Falha ao carregar as informações de indicação',
    referralLinkCopied: 'Link de indicação copiado para a área de transferência',
    referralCodeCopied: 'Código de indicação copiado para a área de transferência',
    shareFailed: 'Falha ao compartilhar',
    shareMessageFailed: 'Falha ao compartilhar a mensagem',
    shareEmailFailed: 'Falha ao compartilhar por e-mail',
    comingSoonTitle: 'Em breve',
    socialSharingSoon: 'O compartilhamento em redes sociais estará disponível em breve!',
    purchaseLoginRequired: 'Você precisa estar logado para assinar',
    purchaseFailedTitle: 'Falha na compra',
    purchaseFailedMessage: 'Não foi possível concluir a compra',
    purchaseError: 'Ocorreu um erro durante a compra',
    restoreLoginRequired: 'Você precisa estar logado para restaurar compras',
    noPurchasesFound: 'Nenhuma compra encontrada',
    noPurchasesMessage: 'Nenhuma compra anterior foi encontrada para restaurar',
    restoreFailedTitle: 'Falha na restauração',
    restoreFailedMessage: 'Não foi possível restaurar as compras',
    restoreError: 'Ocorreu um erro ao restaurar as compras',
    notAuthenticated: 'O usuário não está autenticado.',
    avatarUpdateFailed: 'Falha ao atualizar o avatar.',
    uploadErrorTitle: 'Erro de upload',
    avatarUploadFailed: 'Falha ao enviar o avatar.',
    planInfoMissingShort: 'Faltam as informações do plano. Tente novamente.',
    startGameFailed: 'Falha ao iniciar o jogo. Tente novamente.',
    scoreBreakdown: 'Detalhes da sua pontuação:',
    leaderboardTitle: 'Ranking',
    previous: 'Anterior',
    next: 'Próximo',
    back: 'Voltar',
    ready: 'Pronto',
    beta: 'Beta',
    soon: 'Em breve',
    shareDailyQuiz: 'Compartilhar o quiz diário',
    logoAlt: 'Logotipo do app Kingdom Bible Quiz',
    copiedTitle: 'Copiado!',
    shareTextCopied: 'Texto de compartilhamento copiado para a área de transferência',
    loadingChallenge: 'Carregando o desafio de hoje…',
    questionNotFound: 'Pergunta não encontrada',
    questionOfTheDay: 'Pergunta do dia',
    groupChallenge: 'Desafio em grupo',
    explanation: 'Explicação',
    shareResult: 'Compartilhar resultado',
    downloadFullApp: 'Baixar o app completo',
    demoFamilyName: 'A família Johnson',
    demoFriendsGroupName: 'Grupo de jovens',
    errorTitle: 'Erro',
    successTitle: 'Sucesso',
    ok: 'OK',
    accept: 'Aceitar',
    decline: 'Recusar',
    cancel: 'Cancelar',
    done: 'Concluído',
    notNow: 'Agora não',
    maybeLater: 'Talvez depois',
    tryAgain: 'Tentar novamente',
    loadingQuestion: 'Carregando pergunta…',
    loadingQuiz: 'Carregando quiz…',
    loadingPlans: 'Carregando planos de assinatura…',
    checkingPermissions: 'Verificando permissões…',
    accessDenied: 'Acesso negado',
    noLeaderboardData: 'Sem dados de ranking',
    createGroupTitle: 'Criar grupo de família ou amigos',
    joinFriendsTitle: 'Entrar em amigos com código de convite',
    inviteCodePlaceholder: 'Digite o código de convite…',
    joinFriendsFailed: 'Falha ao entrar no grupo de amigos.',
    leaderboardJoinPrompt: 'Entre ou crie um grupo para ver o ranking!',
    pendingInvitations: 'Convites pendentes',
    hostBadgeHint: 'Este jogador é o anfitrião da sala e pode iniciar o jogo.',
    youBadgeHint: 'Este é você! Só você vê este emblema.',
    noValidRoomId: 'ID de sala inválido.',
    userNotFoundSignIn: 'Usuário não encontrado. Entre novamente.',
    planInfoMissing: 'Faltam as informações do plano atual. Tente novamente.',
    billingPerkYearly1: 'Um pagamento por ano: menos complicação',
    billingPerkYearly2: 'Garanta o preço atual por um ano inteiro',
    billingPerkMonthly1: 'Mais flexibilidade para mudar de plano',
    billingPerkMonthly2: 'Pagamentos mensais menores',
    billingPerkMonthly3: 'Fácil de planejar todo mês',
    gateUnlimited: 'Quizzes diários ilimitados',
    gateFamilyPlay: 'Jogo em família e experiências compartilhadas',
    gateFamilyGrowth: 'Jogo em família e crescimento compartilhado',
    gateInsights: 'Percepções mais profundas e devocionais',
    gateFormats: 'Todos os formatos de perguntas desbloqueados',
    signInRequired: 'Login necessário',
    signInToAccessPremium: 'Entre para acessar os recursos premium.',
    premiumFeatureGroups: 'Crie grupos de estudo bíblico com família e amigos',
    premiumFeatureHost: 'Conduza sessões de quiz bíblico em família',
    premiumFeatureTrack: 'Acompanhe pontuações e o progresso da família',
    availableIn: 'Disponível em',
    plansLoadFailed: 'Falha ao carregar os planos de assinatura. Tente novamente.',
    userNotFoundTryAgain: 'Usuário não encontrado. Tente novamente.',
    subscriptionCanceled: 'Assinatura cancelada',
    subscriptionCanceledMessage: 'Sua assinatura foi cancelada e terminará no fim do período atual.',
    cancelFailed: 'Falha ao cancelar a assinatura. Tente novamente.',
    unexpectedError: 'Ocorreu um erro inesperado. Tente novamente.',
    previewMode: 'Modo de visualização',
    secureCheckout: 'Checkout seguro hospedado no Stripe',
    noCardDetails: 'Nenhum dado de cartão é digitado no app',
    currentSubscription: 'Assinatura atual',
    termsOfUse: 'Termos de uso (EULA)',
    privacyPolicy: 'Política de privacidade',
    cancelPlan: 'Cancelar plano',
    mostPopular: 'MAIS POPULAR',
    currentPlanBadge: 'PLANO ATUAL',
    preview: 'Prévia',
    planLimits: 'Limites do plano:',
    planMembers: 'Até {{count}} membros',
    planMembersUnlimited: 'Membros ilimitados',
    selected: 'Selecionado ✓',
    selectPlan: 'Selecionar plano',
    featUnlimitedQuiz: 'Mais de 30.000 perguntas com acesso diário ilimitado',
    featAdFree: 'Experiência sem anúncios',
    featHistory: 'Histórico de quizzes ilimitado',
    featFormats: '5 formatos de perguntas diferentes (múltipla escolha, verdadeiro/falso, completar, ordenar)',
    featLanguages: '10 idiomas disponíveis (mais em breve)',
    featMpCreate: 'Crie salas de quiz multijogador',
    featMpJoin: 'Entre em salas de quiz multijogador',
    featFamilyAnalytics: 'Acompanhamento do progresso da família',
    featTeam: 'Convide até {{count}} membros da família',
    featPacks: 'Pacotes de quizzes premium',
    signInFailed: 'Falha no login',
    signInFailedMessage: 'Não foi possível concluir o login. Tente novamente.',
    signInError: 'Erro de login',
    quizUnavailable: 'Quiz indisponível',
    quizLinkInvalid: 'Este link de quiz é inválido ou expirou.',
    navigationError: 'Erro de navegação',
    openQuizFailed: 'Falha ao abrir o quiz. Tente novamente.',
    invalidLink: 'Link inválido',
    roomInviteInvalid: 'Este link de convite para a sala é inválido ou expirou.',
    openRoomFailed: 'Falha ao abrir este convite para a sala. Tente novamente.',
    eventInviteInvalid: 'Este link de convite para o evento é inválido ou expirou.',
    eventLinkUnavailable: 'Link de evento indisponível',
    eventLinksUnsupported: 'Links de eventos ao vivo não são mais compatíveis com este app.',
    referralInvalid: 'Este link de indicação é inválido.',
    alreadyRegistered: 'Já registrado',
    alreadyRegisteredMessage: 'Você já tem uma conta! Compartilhe este app com amigos que ainda não entraram.',
    joinKbqTitle: 'Junte-se ao Kingdom Bible Quiz!',
    joinKbqMessage: 'Você foi convidado para o melhor app de quiz bíblico. Crie sua conta para começar!',
    signUp: 'Cadastrar-se',
    signupNavFailed: 'Falha ao abrir o cadastro. Tente novamente.',
    exploredAll: 'Sua família explorou {{count}} perguntas',
    exploredWeek: 'Sua família explorou {{count}} perguntas esta semana',
    exploredMonth: 'Sua família explorou {{count}} perguntas este mês',
    filterWeek: 'Esta semana',
    filterMonth: 'Este mês',
    filterAll: 'Todo o período',
    entryStats: '{{questions}} perguntas exploradas · {{quizzes}} quizzes',
    readyToStart: 'Pronto para começar!',
    statQuizzesTogether: 'Quizzes\njuntos',
    statQuestionsExplored: 'Perguntas\nexploradas',
    statMembersActive: 'Membros\nativos',
  },
  ru: {
    successBang: 'Готово!',
    great: 'Отлично!',
    billingUpdatedTitle: 'Оплата обновлена!',
    billingSwitchedAnnual: 'Оплата переключена на ежегодную. Теперь вы экономите {{percent}}% в год!',
    billingSwitchedMonthly: 'Оплата переключена на ежемесячную. Следующий платёж будет ежемесячным.',
    billingChangeFailedTitle: 'Не удалось изменить оплату',
    billingChangeFailedMessage: 'Не удалось изменить период оплаты. Попробуйте ещё раз.',
    planUpgraded: 'Ваша подписка повышена до {{plan}}. Новые функции уже активны!',
    planDowngraded: 'Ваша подписка изменена на {{plan}}. Новые функции уже активны!',
    planChanged: 'Ваша подписка изменена на {{plan}}. Новые функции уже активны!',
    planChangeFailedTitle: 'Не удалось сменить план',
    planChangeFailedMessage: 'Не удалось сменить план. Попробуйте ещё раз.',
    subscriptionActivated: 'Подписка активирована. Спасибо!',
    purchasesRestoredTitle: 'Покупки восстановлены',
    purchasesRestoredMessage: 'Успешно восстановлено подписок: {{count}}',
    stripeSignInMessage: 'Войдите или создайте аккаунт перед оплатой через Stripe. Прогресс гостя можно будет перенести после входа.',
    previewSuccess: 'Подписка успешно смоделирована! В рабочем режиме платёж был бы обработан.',
    welcomeSubscription: 'Добро пожаловать в вашу новую подписку! Премиум-функции уже активны.',
    processSubscriptionFailed: 'Не удалось оформить подписку. Попробуйте ещё раз.',
    startGameFailedTitle: 'Не удалось начать игру',
    joinRoomFailed: 'Не удалось войти в комнату. Попробуйте ещё раз.',
    joinRoomFailedWithReason: 'Не удалось войти в комнату: {{message}}',
    unknownError: 'Неизвестная ошибка',
    sharedSuccessTitle: 'Успешно отправлено!',
    sharedSuccessMessage: 'Ваша викторина отправлена через {{platform}}. Спасибо, что распространяете знание Библии!',
    shareAnother: 'Поделиться ещё',
    sharingFailedTitle: 'Не удалось поделиться',
    sharingFailedMessage: 'Не удалось поделиться через {{platform}}. Попробуйте ещё раз.',
    sharingErrorTitle: 'Ошибка отправки',
    sharingErrorMessage: 'Ошибка при отправке через {{platform}}. Попробуйте ещё раз.',
    platformSharingTitle: 'Отправка в {{platform}}',
    soonInstagram: 'При отправке в Instagram откроется приложение с готовым содержимым. Эта функция скоро появится!',
    soonTikTok: 'При отправке в TikTok из вашего вопроса будет создан увлекательный видеоролик. Скоро появится с интерактивными шаблонами!',
    soonSnapchat: 'При отправке в Snapchat из ваших вопросов будут созданы визуальные истории. Эта функция скоро появится!',
    soonYouTube: 'Отправка в YouTube позволит публиковать викторины во вкладке «Сообщество» или в описаниях видео. Эта функция скоро появится!',
    linkCopiedTitle: 'Ссылка скопирована!',
    linkCopiedMessage: 'Ссылка на викторину скопирована в буфер обмена. Теперь её можно вставить куда угодно.',
    shareToSlack: 'Поделиться в Slack',
    shareToTeams: 'Поделиться в Microsoft Teams',
    shareToDiscord: 'Поделиться в Discord',
    pasteSlack: 'Содержимое скопировано! Откройте Slack и вставьте его в нужный канал или личное сообщение.',
    pasteTeams: 'Содержимое скопировано! Откройте Microsoft Teams и вставьте его в нужный чат или канал.',
    pasteDiscord: 'Содержимое скопировано! Откройте Discord и вставьте его на нужный сервер или в личное сообщение.',
    downloadAppTitle: 'Скачать Kingdom Bible Quiz',
    downloadAppMessage: 'Получите полный опыт: тысячи вопросов, групповые игры и многое другое!',
    checkoutCompleteTitle: 'Оплата завершена',
    checkoutCompleteMessage: 'Stripe подтверждает вашу подписку. Премиум-доступ скоро обновится.',
    checkoutCancelledTitle: 'Оплата отменена',
    checkoutCancelledMessage: 'Платёж не был завершён. Вы можете вернуться к Premium, когда будете готовы.',
    checkEmailTitle: 'Проверьте почту 📧',
    checkEmailMessage: 'Мы отправили ссылку для подтверждения на:\n\n{{email}}\n\nПроверьте входящие и папку «Спам», затем перейдите по ссылке, чтобы активировать аккаунт.',
    emailSentTitle: 'Письмо отправлено ✅',
    emailSentMessage: 'Проверьте почту — там ссылка для подтверждения.',
    emailSentBanner: 'Письмо отправлено! Проверьте почту.',
    premiumRequiredTitle: 'Требуется Premium',
    premiumRequiredMessage: 'Для этой категории нужна премиум-подписка. Перейдите на Premium, чтобы открыть все {{count}} премиум-категорий!',
    upgradeNow: 'Улучшить сейчас',
    categoryLockedTitle: 'Категория закрыта',
    categoryLockedMessage: 'Достигните уровня {{level}}, чтобы открыть «{{category}}». Сейчас у вас уровень {{current}}.',
    referralLoadFailed: 'Не удалось загрузить данные о приглашениях',
    referralLinkCopied: 'Реферальная ссылка скопирована в буфер обмена',
    referralCodeCopied: 'Реферальный код скопирован в буфер обмена',
    shareFailed: 'Не удалось поделиться',
    shareMessageFailed: 'Не удалось поделиться сообщением',
    shareEmailFailed: 'Не удалось поделиться по e-mail',
    comingSoonTitle: 'Скоро',
    socialSharingSoon: 'Публикация в соцсетях скоро станет доступна!',
    purchaseLoginRequired: 'Чтобы оформить подписку, нужно войти в аккаунт',
    purchaseFailedTitle: 'Покупка не удалась',
    purchaseFailedMessage: 'Не удалось завершить покупку',
    purchaseError: 'При покупке произошла ошибка',
    restoreLoginRequired: 'Чтобы восстановить покупки, нужно войти в аккаунт',
    noPurchasesFound: 'Покупки не найдены',
    noPurchasesMessage: 'Прежних покупок для восстановления не найдено',
    restoreFailedTitle: 'Не удалось восстановить',
    restoreFailedMessage: 'Не удалось восстановить покупки',
    restoreError: 'При восстановлении покупок произошла ошибка',
    notAuthenticated: 'Пользователь не авторизован.',
    avatarUpdateFailed: 'Не удалось обновить аватар.',
    uploadErrorTitle: 'Ошибка загрузки',
    avatarUploadFailed: 'Не удалось загрузить аватар.',
    planInfoMissingShort: 'Нет данных о плане. Попробуйте ещё раз.',
    startGameFailed: 'Не удалось начать игру. Попробуйте ещё раз.',
    scoreBreakdown: 'Разбор вашего результата:',
    leaderboardTitle: 'Таблица лидеров',
    previous: 'Назад',
    next: 'Далее',
    back: 'Назад',
    ready: 'Готово',
    beta: 'Бета',
    soon: 'Скоро',
    shareDailyQuiz: 'Поделиться ежедневной викториной',
    logoAlt: 'Логотип приложения Kingdom Bible Quiz',
    copiedTitle: 'Скопировано!',
    shareTextCopied: 'Текст для публикации скопирован в буфер обмена',
    loadingChallenge: 'Загрузка сегодняшнего испытания…',
    questionNotFound: 'Вопрос не найден',
    questionOfTheDay: 'Вопрос дня',
    groupChallenge: 'Групповое испытание',
    explanation: 'Объяснение',
    shareResult: 'Поделиться результатом',
    downloadFullApp: 'Скачать полное приложение',
    demoFamilyName: 'Семья Джонсон',
    demoFriendsGroupName: 'Молодёжная группа',
    errorTitle: 'Ошибка',
    successTitle: 'Готово',
    ok: 'ОК',
    accept: 'Принять',
    decline: 'Отклонить',
    cancel: 'Отмена',
    done: 'Готово',
    notNow: 'Не сейчас',
    maybeLater: 'Возможно, позже',
    tryAgain: 'Повторить',
    loadingQuestion: 'Загрузка вопроса…',
    loadingQuiz: 'Загрузка викторины…',
    loadingPlans: 'Загрузка планов подписки…',
    checkingPermissions: 'Проверка разрешений…',
    accessDenied: 'Доступ запрещён',
    noLeaderboardData: 'Нет данных таблицы лидеров',
    createGroupTitle: 'Создать группу семьи или друзей',
    joinFriendsTitle: 'Присоединиться к друзьям по коду',
    inviteCodePlaceholder: 'Введите код приглашения…',
    joinFriendsFailed: 'Не удалось присоединиться к группе друзей.',
    leaderboardJoinPrompt: 'Присоединитесь к группе или создайте её, чтобы увидеть таблицу лидеров!',
    pendingInvitations: 'Ожидающие приглашения',
    hostBadgeHint: 'Этот игрок — ведущий комнаты и может начать игру.',
    youBadgeHint: 'Это вы! Только вы видите этот значок.',
    noValidRoomId: 'Недействительный ID комнаты.',
    userNotFoundSignIn: 'Пользователь не найден. Войдите снова.',
    planInfoMissing: 'Нет данных о текущем плане. Попробуйте ещё раз.',
    billingPerkYearly1: 'Один платёж в год — меньше хлопот',
    billingPerkYearly2: 'Зафиксируйте текущую цену на целый год',
    billingPerkMonthly1: 'Больше гибкости при смене плана',
    billingPerkMonthly2: 'Меньшие ежемесячные платежи',
    billingPerkMonthly3: 'Легко планировать бюджет по месяцам',
    gateUnlimited: 'Неограниченные ежедневные викторины',
    gateFamilyPlay: 'Игра с семьёй и общий опыт',
    gateFamilyGrowth: 'Игра с семьёй и совместный рост',
    gateInsights: 'Более глубокие размышления и молитвенные чтения',
    gateFormats: 'Все форматы вопросов открыты',
    signInRequired: 'Требуется вход',
    signInToAccessPremium: 'Войдите, чтобы получить доступ к премиум-функциям.',
    premiumFeatureGroups: 'Создавайте группы изучения Библии с семьёй и друзьями',
    premiumFeatureHost: 'Проводите семейные библейские викторины',
    premiumFeatureTrack: 'Следите за результатами и прогрессом семьи',
    availableIn: 'Доступно в',
    plansLoadFailed: 'Не удалось загрузить планы подписки. Попробуйте ещё раз.',
    userNotFoundTryAgain: 'Пользователь не найден. Попробуйте ещё раз.',
    subscriptionCanceled: 'Подписка отменена',
    subscriptionCanceledMessage: 'Подписка отменена и закончится в конце текущего периода.',
    cancelFailed: 'Не удалось отменить подписку. Попробуйте ещё раз.',
    unexpectedError: 'Произошла непредвиденная ошибка. Попробуйте ещё раз.',
    previewMode: 'Режим предпросмотра',
    secureCheckout: 'Безопасная оплата через Stripe',
    noCardDetails: 'Данные карты в приложении не вводятся',
    currentSubscription: 'Текущая подписка',
    termsOfUse: 'Условия использования (EULA)',
    privacyPolicy: 'Политика конфиденциальности',
    cancelPlan: 'Отменить план',
    mostPopular: 'САМЫЙ ПОПУЛЯРНЫЙ',
    currentPlanBadge: 'ТЕКУЩИЙ ПЛАН',
    preview: 'Предпросмотр',
    planLimits: 'Ограничения плана:',
    planMembers: 'До {{count}} участников',
    planMembersUnlimited: 'Неограниченное число участников',
    selected: 'Выбрано ✓',
    selectPlan: 'Выбрать план',
    featUnlimitedQuiz: 'Более 30 000 вопросов с неограниченным ежедневным доступом',
    featAdFree: 'Без рекламы',
    featHistory: 'Неограниченная история викторин',
    featFormats: '5 разных форматов вопросов (тест, верно/неверно, пропуски, порядок)',
    featLanguages: '10 языков (скоро будут и другие)',
    featMpCreate: 'Создавайте комнаты для групповых викторин',
    featMpJoin: 'Присоединяйтесь к комнатам групповых викторин',
    featFamilyAnalytics: 'Отслеживание прогресса семьи',
    featTeam: 'Приглашайте до {{count}} членов семьи',
    featPacks: 'Премиум-наборы викторин',
    signInFailed: 'Не удалось войти',
    signInFailedMessage: 'Не удалось завершить вход. Попробуйте ещё раз.',
    signInError: 'Ошибка входа',
    quizUnavailable: 'Викторина недоступна',
    quizLinkInvalid: 'Эта ссылка на викторину недействительна или устарела.',
    navigationError: 'Ошибка навигации',
    openQuizFailed: 'Не удалось открыть викторину. Попробуйте ещё раз.',
    invalidLink: 'Недействительная ссылка',
    roomInviteInvalid: 'Эта ссылка-приглашение в комнату недействительна или устарела.',
    openRoomFailed: 'Не удалось открыть приглашение в комнату. Попробуйте ещё раз.',
    eventInviteInvalid: 'Эта ссылка-приглашение на событие недействительна или устарела.',
    eventLinkUnavailable: 'Ссылка на событие недоступна',
    eventLinksUnsupported: 'Ссылки на живые события в этом приложении больше не поддерживаются.',
    referralInvalid: 'Эта реферальная ссылка недействительна.',
    alreadyRegistered: 'Уже зарегистрированы',
    alreadyRegisteredMessage: 'У вас уже есть аккаунт! Поделитесь приложением с друзьями, которые ещё не присоединились.',
    joinKbqTitle: 'Присоединяйтесь к Kingdom Bible Quiz!',
    joinKbqMessage: 'Вас пригласили в лучшее приложение библейских викторин. Создайте аккаунт, чтобы начать!',
    signUp: 'Зарегистрироваться',
    signupNavFailed: 'Не удалось открыть регистрацию. Попробуйте ещё раз.',
    exploredAll: 'Ваша семья изучила {{count}} вопросов',
    exploredWeek: 'Ваша семья изучила {{count}} вопросов за эту неделю',
    exploredMonth: 'Ваша семья изучила {{count}} вопросов за этот месяц',
    filterWeek: 'Эта неделя',
    filterMonth: 'Этот месяц',
    filterAll: 'За всё время',
    entryStats: '{{questions}} вопросов изучено · {{quizzes}} викторин',
    readyToStart: 'Готов начать!',
    statQuizzesTogether: 'Викторин\nвместе',
    statQuestionsExplored: 'Вопросов\nизучено',
    statMembersActive: 'Активных\nучастников',
  },
  it: {
    successBang: 'Fatto!',
    great: 'Ottimo!',
    billingUpdatedTitle: 'Fatturazione aggiornata!',
    billingSwitchedAnnual: 'La fatturazione è passata ai pagamenti annuali. Ora risparmi il {{percent}}% all\'anno!',
    billingSwitchedMonthly: 'La fatturazione è passata ai pagamenti mensili. Il prossimo pagamento sarà mensile.',
    billingChangeFailedTitle: 'Modifica della fatturazione non riuscita',
    billingChangeFailedMessage: 'Impossibile modificare il ciclo di fatturazione. Riprova.',
    planUpgraded: 'Il tuo abbonamento è passato a {{plan}}. Le nuove funzioni sono ora attive!',
    planDowngraded: 'Il tuo abbonamento è passato a {{plan}}. Le nuove funzioni sono ora attive!',
    planChanged: 'Il tuo abbonamento è stato cambiato in {{plan}}. Le nuove funzioni sono ora attive!',
    planChangeFailedTitle: 'Cambio di piano non riuscito',
    planChangeFailedMessage: 'Impossibile cambiare il piano. Riprova.',
    subscriptionActivated: 'Il tuo abbonamento è stato attivato. Grazie!',
    purchasesRestoredTitle: 'Acquisti ripristinati',
    purchasesRestoredMessage: 'Ripristinati con successo {{count}} abbonamento/i',
    stripeSignInMessage: 'Accedi o crea un account prima di avviare il checkout Stripe. I progressi da ospite potranno essere trasferiti dopo l\'accesso.',
    previewSuccess: 'Abbonamento simulato con successo! In modalità reale il pagamento verrebbe elaborato.',
    welcomeSubscription: 'Benvenuto nel tuo nuovo abbonamento! Le funzioni premium sono ora attive.',
    processSubscriptionFailed: 'Impossibile elaborare l\'abbonamento. Riprova.',
    startGameFailedTitle: 'Avvio della partita non riuscito',
    joinRoomFailed: 'Impossibile unirsi alla stanza. Riprova.',
    joinRoomFailedWithReason: 'Impossibile unirsi alla stanza: {{message}}',
    unknownError: 'Errore sconosciuto',
    sharedSuccessTitle: 'Condiviso con successo!',
    sharedSuccessMessage: 'Il tuo quiz è stato condiviso tramite {{platform}}. Grazie per diffondere la conoscenza biblica!',
    shareAnother: 'Condividi un altro',
    sharingFailedTitle: 'Condivisione non riuscita',
    sharingFailedMessage: 'Impossibile condividere tramite {{platform}}. Riprova.',
    sharingErrorTitle: 'Errore di condivisione',
    sharingErrorMessage: 'Si è verificato un errore durante la condivisione su {{platform}}. Riprova.',
    platformSharingTitle: 'Condivisione su {{platform}}',
    soonInstagram: 'La condivisione su Instagram aprirà l\'app di Instagram con contenuti precompilati. Questa funzione arriverà presto!',
    soonTikTok: 'La condivisione su TikTok creerà un video coinvolgente dalla tua domanda. Questa funzione arriverà presto con modelli video interattivi!',
    soonSnapchat: 'La condivisione su Snapchat creerà storie visive dalle tue domande. Questa funzione arriverà presto!',
    soonYouTube: 'La condivisione su YouTube ti permetterà di pubblicare contenuti del quiz nella scheda community o nelle descrizioni dei video. Questa funzione arriverà presto!',
    linkCopiedTitle: 'Link copiato!',
    linkCopiedMessage: 'Il link del quiz è stato copiato negli appunti. Ora puoi incollarlo dove vuoi condividerlo.',
    shareToSlack: 'Condividi su Slack',
    shareToTeams: 'Condividi su Microsoft Teams',
    shareToDiscord: 'Condividi su Discord',
    pasteSlack: 'Contenuto copiato! Apri Slack e incollalo nel canale o nel messaggio diretto che preferisci.',
    pasteTeams: 'Contenuto copiato! Apri Microsoft Teams e incollalo nella chat o nel canale che preferisci.',
    pasteDiscord: 'Contenuto copiato! Apri Discord e incollalo nel server o nel messaggio diretto che preferisci.',
    downloadAppTitle: 'Scarica Kingdom Bible Quiz',
    downloadAppMessage: 'Scopri l\'esperienza completa con migliaia di domande, giochi multigiocatore e molto altro!',
    checkoutCompleteTitle: 'Checkout completato',
    checkoutCompleteMessage: 'Stripe sta confermando il tuo abbonamento. L\'accesso premium si aggiornerà a breve.',
    checkoutCancelledTitle: 'Checkout annullato',
    checkoutCancelledMessage: 'Nessun pagamento è stato completato. Puoi tornare a Premium quando vuoi.',
    checkEmailTitle: 'Controlla la tua e-mail 📧',
    checkEmailMessage: 'Abbiamo inviato un link di conferma a:\n\n{{email}}\n\nControlla la posta in arrivo e lo spam, poi fai clic sul link per attivare il tuo account.',
    emailSentTitle: 'E-mail inviata ✅',
    emailSentMessage: 'Controlla la posta in arrivo per il link di conferma.',
    emailSentBanner: 'E-mail inviata! Controlla la posta in arrivo.',
    premiumRequiredTitle: 'Premium richiesto',
    premiumRequiredMessage: 'Questa categoria richiede un abbonamento premium. Passa a Premium per sbloccare tutte le {{count}} categorie premium!',
    upgradeNow: 'Passa a Premium ora',
    categoryLockedTitle: 'Categoria bloccata',
    categoryLockedMessage: 'Raggiungi il livello {{level}} per sbloccare "{{category}}". Ora sei al livello {{current}}.',
    referralLoadFailed: 'Impossibile caricare le informazioni sugli inviti',
    referralLinkCopied: 'Link di invito copiato negli appunti',
    referralCodeCopied: 'Codice invito copiato negli appunti',
    shareFailed: 'Condivisione non riuscita',
    shareMessageFailed: 'Impossibile condividere il messaggio',
    shareEmailFailed: 'Impossibile condividere via e-mail',
    comingSoonTitle: 'Prossimamente',
    socialSharingSoon: 'La condivisione sui social sarà disponibile a breve!',
    purchaseLoginRequired: 'Devi aver effettuato l\'accesso per abbonarti',
    purchaseFailedTitle: 'Acquisto non riuscito',
    purchaseFailedMessage: 'Impossibile completare l\'acquisto',
    purchaseError: 'Si è verificato un errore durante l\'acquisto',
    restoreLoginRequired: 'Devi aver effettuato l\'accesso per ripristinare gli acquisti',
    noPurchasesFound: 'Nessun acquisto trovato',
    noPurchasesMessage: 'Non sono stati trovati acquisti precedenti da ripristinare',
    restoreFailedTitle: 'Ripristino non riuscito',
    restoreFailedMessage: 'Impossibile ripristinare gli acquisti',
    restoreError: 'Si è verificato un errore durante il ripristino degli acquisti',
    notAuthenticated: 'L\'utente non è autenticato.',
    avatarUpdateFailed: 'Impossibile aggiornare l\'avatar.',
    uploadErrorTitle: 'Errore di caricamento',
    avatarUploadFailed: 'Impossibile caricare l\'avatar.',
    planInfoMissingShort: 'Mancano le informazioni sul piano. Riprova.',
    startGameFailed: 'Impossibile avviare la partita. Riprova.',
    scoreBreakdown: 'Dettaglio del tuo punteggio:',
    leaderboardTitle: 'Classifica',
    previous: 'Precedente',
    next: 'Successivo',
    back: 'Indietro',
    ready: 'Pronto',
    beta: 'Beta',
    soon: 'Presto',
    shareDailyQuiz: 'Condividi il quiz del giorno',
    logoAlt: 'Logo dell\'app Kingdom Bible Quiz',
    copiedTitle: 'Copiato!',
    shareTextCopied: 'Testo da condividere copiato negli appunti',
    loadingChallenge: 'Caricamento della sfida di oggi…',
    questionNotFound: 'Domanda non trovata',
    questionOfTheDay: 'Domanda del giorno',
    groupChallenge: 'Sfida di gruppo',
    explanation: 'Spiegazione',
    shareResult: 'Condividi il risultato',
    downloadFullApp: 'Scarica l\'app completa',
    demoFamilyName: 'La famiglia Johnson',
    demoFriendsGroupName: 'Gruppo giovani',
    errorTitle: 'Errore',
    successTitle: 'Fatto',
    ok: 'OK',
    accept: 'Accetta',
    decline: 'Rifiuta',
    cancel: 'Annulla',
    done: 'Fatto',
    notNow: 'Non ora',
    maybeLater: 'Forse più tardi',
    tryAgain: 'Riprova',
    loadingQuestion: 'Caricamento della domanda…',
    loadingQuiz: 'Caricamento del quiz…',
    loadingPlans: 'Caricamento dei piani di abbonamento…',
    checkingPermissions: 'Verifica dei permessi…',
    accessDenied: 'Accesso negato',
    noLeaderboardData: 'Nessun dato di classifica',
    createGroupTitle: 'Crea un gruppo di famiglia o amici',
    joinFriendsTitle: 'Unisciti agli amici con il codice invito',
    inviteCodePlaceholder: 'Inserisci il codice invito…',
    joinFriendsFailed: 'Impossibile unirsi al gruppo di amici.',
    leaderboardJoinPrompt: 'Unisciti o crea un gruppo per vedere la classifica!',
    pendingInvitations: 'Inviti in sospeso',
    hostBadgeHint: 'Questo giocatore è l\'host della stanza e può avviare la partita.',
    youBadgeHint: 'Sei tu! Solo tu vedi questo badge.',
    noValidRoomId: 'ID stanza non valido.',
    userNotFoundSignIn: 'Utente non trovato. Accedi di nuovo.',
    planInfoMissing: 'Mancano le informazioni sul piano attuale. Riprova.',
    billingPerkYearly1: 'Un solo pagamento all\'anno: meno pensieri',
    billingPerkYearly2: 'Blocca il prezzo attuale per un anno intero',
    billingPerkMonthly1: 'Più flessibilità per cambiare piano',
    billingPerkMonthly2: 'Pagamenti mensili più piccoli',
    billingPerkMonthly3: 'Facile da pianificare ogni mese',
    gateUnlimited: 'Quiz giornalieri illimitati',
    gateFamilyPlay: 'Gioco in famiglia ed esperienze condivise',
    gateFamilyGrowth: 'Gioco in famiglia e crescita condivisa',
    gateInsights: 'Approfondimenti e devozionali',
    gateFormats: 'Tutti i formati di domande sbloccati',
    signInRequired: 'Accesso richiesto',
    signInToAccessPremium: 'Accedi per usare le funzioni premium.',
    premiumFeatureGroups: 'Crea gruppi di studio biblico con famiglia e amici',
    premiumFeatureHost: 'Conduci sessioni di quiz biblico in famiglia',
    premiumFeatureTrack: 'Segui i punteggi e i progressi della famiglia',
    availableIn: 'Disponibile in',
    plansLoadFailed: 'Impossibile caricare i piani di abbonamento. Riprova.',
    userNotFoundTryAgain: 'Utente non trovato. Riprova.',
    subscriptionCanceled: 'Abbonamento annullato',
    subscriptionCanceledMessage: 'Il tuo abbonamento è stato annullato e terminerà alla fine del periodo corrente.',
    cancelFailed: 'Impossibile annullare l\'abbonamento. Riprova.',
    unexpectedError: 'Si è verificato un errore imprevisto. Riprova.',
    previewMode: 'Modalità anteprima',
    secureCheckout: 'Checkout sicuro ospitato da Stripe',
    noCardDetails: 'Nessun dato della carta viene inserito nell\'app',
    currentSubscription: 'Abbonamento attuale',
    termsOfUse: 'Termini di utilizzo (EULA)',
    privacyPolicy: 'Informativa sulla privacy',
    cancelPlan: 'Annulla piano',
    mostPopular: 'PIÙ POPOLARE',
    currentPlanBadge: 'PIANO ATTUALE',
    preview: 'Anteprima',
    planLimits: 'Limiti del piano:',
    planMembers: 'Fino a {{count}} membri',
    planMembersUnlimited: 'Membri illimitati',
    selected: 'Selezionato ✓',
    selectPlan: 'Seleziona piano',
    featUnlimitedQuiz: 'Oltre 30.000 domande con accesso giornaliero illimitato',
    featAdFree: 'Esperienza senza pubblicità',
    featHistory: 'Cronologia dei quiz illimitata',
    featFormats: '5 diversi formati di domande (scelta multipla, vero/falso, completamento, ordinamento)',
    featLanguages: '10 lingue disponibili (altre in arrivo)',
    featMpCreate: 'Crea stanze quiz multigiocatore',
    featMpJoin: 'Unisciti a stanze quiz multigiocatore',
    featFamilyAnalytics: 'Monitoraggio dei progressi della famiglia',
    featTeam: 'Invita fino a {{count}} familiari',
    featPacks: 'Pacchetti di quiz premium',
    signInFailed: 'Accesso non riuscito',
    signInFailedMessage: 'Impossibile completare l\'accesso. Riprova.',
    signInError: 'Errore di accesso',
    quizUnavailable: 'Quiz non disponibile',
    quizLinkInvalid: 'Questo link del quiz non è valido o è scaduto.',
    navigationError: 'Errore di navigazione',
    openQuizFailed: 'Impossibile aprire il quiz. Riprova.',
    invalidLink: 'Link non valido',
    roomInviteInvalid: 'Questo link di invito alla stanza non è valido o è scaduto.',
    openRoomFailed: 'Impossibile aprire questo invito alla stanza. Riprova.',
    eventInviteInvalid: 'Questo link di invito all\'evento non è valido o è scaduto.',
    eventLinkUnavailable: 'Link evento non disponibile',
    eventLinksUnsupported: 'I link degli eventi dal vivo non sono più supportati in questa app.',
    referralInvalid: 'Questo link di invito non è valido.',
    alreadyRegistered: 'Già registrato',
    alreadyRegisteredMessage: 'Hai già un account! Condividi l\'app con gli amici che non si sono ancora iscritti.',
    joinKbqTitle: 'Unisciti a Kingdom Bible Quiz!',
    joinKbqMessage: 'Sei stato invitato alla migliore app di quiz biblico. Crea il tuo account per iniziare!',
    signUp: 'Registrati',
    signupNavFailed: 'Impossibile aprire la registrazione. Riprova.',
    exploredAll: 'La tua famiglia ha esplorato {{count}} domande',
    exploredWeek: 'La tua famiglia ha esplorato {{count}} domande questa settimana',
    exploredMonth: 'La tua famiglia ha esplorato {{count}} domande questo mese',
    filterWeek: 'Questa settimana',
    filterMonth: 'Questo mese',
    filterAll: 'Di sempre',
    entryStats: '{{questions}} domande esplorate · {{quizzes}} quiz',
    readyToStart: 'Pronto per iniziare!',
    statQuizzesTogether: 'Quiz\ninsieme',
    statQuestionsExplored: 'Domande\nesplorate',
    statMembersActive: 'Membri\nattivi',
  },
  ko: {
    successBang: '성공!',
    great: '좋아요!',
    billingUpdatedTitle: '결제 방식이 변경되었습니다!',
    billingSwitchedAnnual: '결제가 연간 결제로 변경되었습니다. 이제 연 {{percent}}%를 절약해요!',
    billingSwitchedMonthly: '결제가 월간 결제로 변경되었습니다. 다음 결제는 월 단위로 진행됩니다.',
    billingChangeFailedTitle: '결제 방식 변경 실패',
    billingChangeFailedMessage: '결제 주기를 변경할 수 없습니다. 다시 시도해 주세요.',
    planUpgraded: '구독이 {{plan}}(으)로 업그레이드되었습니다. 새 기능이 활성화되었어요!',
    planDowngraded: '구독이 {{plan}}(으)로 변경되었습니다. 새 기능이 활성화되었어요!',
    planChanged: '구독이 {{plan}}(으)로 변경되었습니다. 새 기능이 활성화되었어요!',
    planChangeFailedTitle: '플랜 변경 실패',
    planChangeFailedMessage: '플랜을 변경할 수 없습니다. 다시 시도해 주세요.',
    subscriptionActivated: '구독이 활성화되었습니다. 감사합니다!',
    purchasesRestoredTitle: '구매가 복원되었습니다',
    purchasesRestoredMessage: '구독 {{count}}개를 복원했습니다',
    stripeSignInMessage: 'Stripe 결제를 시작하기 전에 로그인하거나 계정을 만드세요. 게스트 진행 상황은 로그인 후 이전할 수 있습니다.',
    previewSuccess: '구독이 시뮬레이션되었습니다! 실제 모드에서는 결제가 처리됩니다.',
    welcomeSubscription: '새 구독을 환영합니다! 프리미엄 기능이 활성화되었어요.',
    processSubscriptionFailed: '구독을 처리할 수 없습니다. 다시 시도해 주세요.',
    startGameFailedTitle: '게임 시작 실패',
    joinRoomFailed: '방에 참여하지 못했습니다. 다시 시도해 주세요.',
    joinRoomFailedWithReason: '방에 참여하지 못했습니다: {{message}}',
    unknownError: '알 수 없는 오류',
    sharedSuccessTitle: '공유되었습니다!',
    sharedSuccessMessage: '퀴즈를 {{platform}}(으)로 공유했습니다. 성경 지식을 나눠 주셔서 감사합니다!',
    shareAnother: '다른 퀴즈 공유',
    sharingFailedTitle: '공유 실패',
    sharingFailedMessage: '{{platform}}(으)로 공유할 수 없습니다. 다시 시도해 주세요.',
    sharingErrorTitle: '공유 오류',
    sharingErrorMessage: '{{platform}}(으)로 공유하는 중 오류가 발생했습니다. 다시 시도해 주세요.',
    platformSharingTitle: '{{platform}} 공유',
    soonInstagram: 'Instagram 공유는 미리 채워진 내용으로 Instagram 앱을 엽니다. 곧 제공될 예정입니다!',
    soonTikTok: 'TikTok 공유는 퀴즈 문제로 흥미로운 영상을 만들어 줍니다. 인터랙티브 영상 템플릿과 함께 곧 제공됩니다!',
    soonSnapchat: 'Snapchat 공유는 퀴즈 문제로 시각적인 스토리를 만들어 줍니다. 곧 제공될 예정입니다!',
    soonYouTube: 'YouTube 공유로 커뮤니티 탭이나 영상 설명에 퀴즈 콘텐츠를 게시할 수 있습니다. 곧 제공될 예정입니다!',
    linkCopiedTitle: '링크가 복사되었습니다!',
    linkCopiedMessage: '퀴즈 링크가 클립보드에 복사되었습니다. 원하는 곳에 붙여 넣어 공유하세요.',
    shareToSlack: 'Slack으로 공유',
    shareToTeams: 'Microsoft Teams로 공유',
    shareToDiscord: 'Discord로 공유',
    pasteSlack: '내용이 복사되었습니다! Slack을 열고 원하는 채널이나 DM에 붙여 넣으세요.',
    pasteTeams: '내용이 복사되었습니다! Microsoft Teams를 열고 원하는 채팅이나 채널에 붙여 넣으세요.',
    pasteDiscord: '내용이 복사되었습니다! Discord를 열고 원하는 서버나 DM에 붙여 넣으세요.',
    downloadAppTitle: 'Kingdom Bible Quiz 다운로드',
    downloadAppMessage: '수천 개의 문제와 멀티플레이 게임 등 전체 경험을 만나 보세요!',
    checkoutCompleteTitle: '결제 완료',
    checkoutCompleteMessage: 'Stripe가 구독을 확인하고 있습니다. 프리미엄 이용 권한이 곧 갱신됩니다.',
    checkoutCancelledTitle: '결제 취소됨',
    checkoutCancelledMessage: '결제가 완료되지 않았습니다. 준비되면 언제든 프리미엄으로 돌아오세요.',
    checkEmailTitle: '이메일을 확인하세요 📧',
    checkEmailMessage: '확인 링크를 다음 주소로 보냈습니다:\n\n{{email}}\n\n받은 편지함과 스팸함을 확인한 뒤 링크를 눌러 계정을 활성화하세요.',
    emailSentTitle: '이메일 전송됨 ✅',
    emailSentMessage: '받은 편지함에서 확인 링크를 확인하세요.',
    emailSentBanner: '이메일을 보냈습니다! 받은 편지함을 확인하세요.',
    premiumRequiredTitle: '프리미엄 필요',
    premiumRequiredMessage: '이 카테고리는 프리미엄 구독이 필요합니다. 업그레이드하면 프리미엄 카테고리 {{count}}개를 모두 이용할 수 있어요!',
    upgradeNow: '지금 업그레이드',
    categoryLockedTitle: '잠긴 카테고리',
    categoryLockedMessage: '레벨 {{level}}에 도달하면 "{{category}}"의 잠금이 해제됩니다. 현재 레벨은 {{current}}입니다.',
    referralLoadFailed: '추천 정보를 불러오지 못했습니다',
    referralLinkCopied: '추천 링크가 클립보드에 복사되었습니다',
    referralCodeCopied: '추천 코드가 클립보드에 복사되었습니다',
    shareFailed: '공유하지 못했습니다',
    shareMessageFailed: '메시지를 공유하지 못했습니다',
    shareEmailFailed: '이메일로 공유하지 못했습니다',
    comingSoonTitle: '곧 출시',
    socialSharingSoon: '소셜 미디어 공유가 곧 제공됩니다!',
    purchaseLoginRequired: '구독하려면 로그인해야 합니다',
    purchaseFailedTitle: '구매 실패',
    purchaseFailedMessage: '구매를 완료할 수 없습니다',
    purchaseError: '구매 중 오류가 발생했습니다',
    restoreLoginRequired: '구매를 복원하려면 로그인해야 합니다',
    noPurchasesFound: '구매 내역이 없습니다',
    noPurchasesMessage: '복원할 이전 구매 내역이 없습니다',
    restoreFailedTitle: '복원 실패',
    restoreFailedMessage: '구매를 복원할 수 없습니다',
    restoreError: '구매를 복원하는 중 오류가 발생했습니다',
    notAuthenticated: '사용자가 인증되지 않았습니다.',
    avatarUpdateFailed: '아바타를 업데이트하지 못했습니다.',
    uploadErrorTitle: '업로드 오류',
    avatarUploadFailed: '아바타를 업로드하지 못했습니다.',
    planInfoMissingShort: '플랜 정보가 없습니다. 다시 시도해 주세요.',
    startGameFailed: '게임을 시작하지 못했습니다. 다시 시도해 주세요.',
    scoreBreakdown: '점수 상세 내역:',
    leaderboardTitle: '순위표',
    previous: '이전',
    next: '다음',
    back: '뒤로',
    ready: '사용 가능',
    beta: '베타',
    soon: '곧 출시',
    shareDailyQuiz: '오늘의 퀴즈 공유',
    logoAlt: 'Kingdom Bible Quiz 앱 로고',
    copiedTitle: '복사됨!',
    shareTextCopied: '공유 문구가 클립보드에 복사되었습니다',
    loadingChallenge: '오늘의 도전을 불러오는 중…',
    questionNotFound: '문제를 찾을 수 없습니다',
    questionOfTheDay: '오늘의 질문',
    groupChallenge: '그룹 도전',
    explanation: '설명',
    shareResult: '결과 공유',
    downloadFullApp: '전체 앱 다운로드',
    demoFamilyName: '존슨 가족',
    demoFriendsGroupName: '청년부',
    errorTitle: '오류',
    successTitle: '성공',
    ok: '확인',
    accept: '수락',
    decline: '거절',
    cancel: '취소',
    done: '완료',
    notNow: '나중에',
    maybeLater: '나중에 하기',
    tryAgain: '다시 시도',
    loadingQuestion: '질문을 불러오는 중…',
    loadingQuiz: '퀴즈를 불러오는 중…',
    loadingPlans: '구독 플랜을 불러오는 중…',
    checkingPermissions: '권한을 확인하는 중…',
    accessDenied: '접근이 거부되었습니다',
    noLeaderboardData: '순위표 데이터가 없습니다',
    createGroupTitle: '가족 또는 친구 그룹 만들기',
    joinFriendsTitle: '초대 코드로 친구 그룹 참여',
    inviteCodePlaceholder: '초대 코드를 입력하세요…',
    joinFriendsFailed: '친구 그룹에 참여하지 못했습니다.',
    leaderboardJoinPrompt: '그룹에 참여하거나 만들면 순위표를 볼 수 있어요!',
    pendingInvitations: '대기 중인 초대',
    hostBadgeHint: '이 플레이어는 방장이며 게임을 시작할 수 있습니다.',
    youBadgeHint: '바로 당신입니다! 이 배지는 본인만 볼 수 있어요.',
    noValidRoomId: '유효한 방 ID가 없습니다.',
    userNotFoundSignIn: '사용자를 찾을 수 없습니다. 다시 로그인해 주세요.',
    planInfoMissing: '현재 플랜 정보가 없습니다. 다시 시도해 주세요.',
    billingPerkYearly1: '연 1회 결제로 더 간편하게',
    billingPerkYearly2: '1년 동안 현재 가격 유지',
    billingPerkMonthly1: '플랜을 바꾸기 더 유연함',
    billingPerkMonthly2: '더 작은 월 결제 금액',
    billingPerkMonthly3: '매달 예산 잡기 쉬움',
    gateUnlimited: '매일 무제한 퀴즈',
    gateFamilyPlay: '가족과 함께하는 플레이와 공유 경험',
    gateFamilyGrowth: '가족과 함께하는 플레이와 함께 성장',
    gateInsights: '더 깊은 통찰과 묵상',
    gateFormats: '모든 문제 유형 잠금 해제',
    signInRequired: '로그인이 필요합니다',
    signInToAccessPremium: '프리미엄 기능을 이용하려면 로그인하세요.',
    premiumFeatureGroups: '가족·친구와 성경 공부 그룹 만들기',
    premiumFeatureHost: '가족 성경 퀴즈 진행하기',
    premiumFeatureTrack: '점수와 가족의 진행 상황 확인하기',
    availableIn: '이용 가능 위치',
    plansLoadFailed: '구독 플랜을 불러오지 못했습니다. 다시 시도해 주세요.',
    userNotFoundTryAgain: '사용자를 찾을 수 없습니다. 다시 시도해 주세요.',
    subscriptionCanceled: '구독이 취소되었습니다',
    subscriptionCanceledMessage: '구독이 취소되었으며 현재 기간이 끝나면 종료됩니다.',
    cancelFailed: '구독을 취소하지 못했습니다. 다시 시도해 주세요.',
    unexpectedError: '예기치 않은 오류가 발생했습니다. 다시 시도해 주세요.',
    previewMode: '미리보기 모드',
    secureCheckout: 'Stripe의 안전한 결제 페이지',
    noCardDetails: '앱에서는 카드 정보를 입력하지 않습니다',
    currentSubscription: '현재 구독',
    termsOfUse: '이용 약관(EULA)',
    privacyPolicy: '개인정보 처리방침',
    cancelPlan: '플랜 취소',
    mostPopular: '가장 인기',
    currentPlanBadge: '현재 플랜',
    preview: '미리보기',
    planLimits: '플랜 한도:',
    planMembers: '최대 {{count}}명',
    planMembersUnlimited: '무제한 멤버',
    selected: '선택됨 ✓',
    selectPlan: '플랜 선택',
    featUnlimitedQuiz: '30,000개 이상의 문제를 매일 무제한으로',
    featAdFree: '광고 없는 환경',
    featHistory: '무제한 퀴즈 기록',
    featFormats: '5가지 문제 유형(객관식, O/X, 빈칸 채우기, 순서 맞추기)',
    featLanguages: '10개 언어 지원(곧 추가 예정)',
    featMpCreate: '멀티플레이 퀴즈 방 만들기',
    featMpJoin: '멀티플레이 퀴즈 방 참여하기',
    featFamilyAnalytics: '가족 진행 상황 추적',
    featTeam: '가족 최대 {{count}}명 초대',
    featPacks: '프리미엄 퀴즈 팩',
    signInFailed: '로그인 실패',
    signInFailedMessage: '로그인을 완료하지 못했습니다. 다시 시도해 주세요.',
    signInError: '로그인 오류',
    quizUnavailable: '퀴즈를 사용할 수 없음',
    quizLinkInvalid: '이 퀴즈 링크가 유효하지 않거나 만료되었습니다.',
    navigationError: '이동 오류',
    openQuizFailed: '퀴즈를 열지 못했습니다. 다시 시도해 주세요.',
    invalidLink: '잘못된 링크',
    roomInviteInvalid: '이 방 초대 링크가 유효하지 않거나 만료되었습니다.',
    openRoomFailed: '이 방 초대를 열지 못했습니다. 다시 시도해 주세요.',
    eventInviteInvalid: '이 이벤트 초대 링크가 유효하지 않거나 만료되었습니다.',
    eventLinkUnavailable: '이벤트 링크를 사용할 수 없음',
    eventLinksUnsupported: '라이브 이벤트 링크는 더 이상 이 앱에서 지원되지 않습니다.',
    referralInvalid: '이 추천 링크가 유효하지 않습니다.',
    alreadyRegistered: '이미 가입됨',
    alreadyRegisteredMessage: '이미 계정이 있습니다! 아직 가입하지 않은 친구에게 이 앱을 공유해 보세요.',
    joinKbqTitle: 'Kingdom Bible Quiz에 참여하세요!',
    joinKbqMessage: '최고의 성경 퀴즈 앱에 초대받았습니다. 계정을 만들어 시작해 보세요!',
    signUp: '가입하기',
    signupNavFailed: '가입 화면으로 이동하지 못했습니다. 다시 시도해 주세요.',
    exploredAll: '가족이 {{count}}개의 문제를 탐구했습니다',
    exploredWeek: '이번 주 가족이 {{count}}개의 문제를 탐구했습니다',
    exploredMonth: '이번 달 가족이 {{count}}개의 문제를 탐구했습니다',
    filterWeek: '이번 주',
    filterMonth: '이번 달',
    filterAll: '전체 기간',
    entryStats: '문제 {{questions}}개 탐구 · 퀴즈 {{quizzes}}개',
    readyToStart: '시작할 준비가 되었어요!',
    statQuizzesTogether: '함께 푼\n퀴즈',
    statQuestionsExplored: '탐구한\n문제',
    statMembersActive: '활동\n멤버',
  },
  tl: {
    successBang: 'Tagumpay!',
    great: 'Magaling!',
    billingUpdatedTitle: 'Na-update ang Billing!',
    billingSwitchedAnnual: 'Naging taunan na ang iyong billing. Nakakatipid ka na ng {{percent}}% kada taon!',
    billingSwitchedMonthly: 'Naging buwanan na ang iyong billing. Buwanan na rin ang susunod mong bayad.',
    billingChangeFailedTitle: 'Nabigo ang Pagbabago ng Billing',
    billingChangeFailedMessage: 'Hindi mabago ang iyong billing cycle. Pakisubukang muli.',
    planUpgraded: 'Na-upgrade ang iyong subscription sa {{plan}}. Aktibo na ang mga bago mong feature!',
    planDowngraded: 'Na-downgrade ang iyong subscription sa {{plan}}. Aktibo na ang mga bago mong feature!',
    planChanged: 'Napalitan ang iyong subscription sa {{plan}}. Aktibo na ang mga bago mong feature!',
    planChangeFailedTitle: 'Nabigo ang Pagpapalit ng Plan',
    planChangeFailedMessage: 'Hindi mapalitan ang iyong plan. Pakisubukang muli.',
    subscriptionActivated: 'Na-activate na ang iyong subscription. Salamat!',
    purchasesRestoredTitle: 'Naibalik ang mga Pagbili',
    purchasesRestoredMessage: 'Matagumpay na naibalik ang {{count}} subscription',
    stripeSignInMessage: 'Mag-sign in o gumawa ng account bago simulan ang Stripe Checkout. Maaaring ilipat ang iyong guest progress pagkatapos mag-sign in.',
    previewSuccess: 'Matagumpay na na-simulate ang subscription! Sa live mode, ipoproseso ang bayad.',
    welcomeSubscription: 'Maligayang pagdating sa iyong bagong subscription! Aktibo na ang iyong mga premium na feature.',
    processSubscriptionFailed: 'Hindi maproseso ang subscription. Pakisubukang muli.',
    startGameFailedTitle: 'Nabigo ang Pagsisimula ng Laro',
    joinRoomFailed: 'Hindi nakasali sa kuwarto. Pakisubukang muli.',
    joinRoomFailedWithReason: 'Hindi nakasali sa kuwarto: {{message}}',
    unknownError: 'Hindi kilalang error',
    sharedSuccessTitle: 'Matagumpay na Naibahagi!',
    sharedSuccessMessage: 'Naibahagi ang iyong quiz sa {{platform}}. Salamat sa pagpapalaganap ng kaalaman sa Bibliya!',
    shareAnother: 'Magbahagi Pa',
    sharingFailedTitle: 'Nabigo ang Pagbabahagi',
    sharingFailedMessage: 'Hindi maibahagi sa {{platform}}. Pakisubukang muli.',
    sharingErrorTitle: 'Error sa Pagbabahagi',
    sharingErrorMessage: 'May naganap na error habang ibinabahagi sa {{platform}}. Pakisubukang muli.',
    platformSharingTitle: 'Pagbabahagi sa {{platform}}',
    soonInstagram: 'Bubuksan ng pagbabahagi sa Instagram ang Instagram app na may nakahandang nilalaman. Malapit na ang feature na ito!',
    soonTikTok: 'Lilikha ang pagbabahagi sa TikTok ng nakakaengganyong video mula sa iyong tanong. Malapit na ito kasama ang interactive na video template!',
    soonSnapchat: 'Lilikha ang pagbabahagi sa Snapchat ng mga visual na story mula sa iyong mga tanong. Malapit na ang feature na ito!',
    soonYouTube: 'Hahayaan ka ng pagbabahagi sa YouTube na mag-post ng nilalaman ng quiz sa community tab o sa mga paglalarawan ng video. Malapit na ang feature na ito!',
    linkCopiedTitle: 'Nakopya ang Link!',
    linkCopiedMessage: 'Nakopya sa clipboard ang link ng quiz. Maaari mo na itong i-paste kahit saan mo gustong ibahagi.',
    shareToSlack: 'Ibahagi sa Slack',
    shareToTeams: 'Ibahagi sa Microsoft Teams',
    shareToDiscord: 'Ibahagi sa Discord',
    pasteSlack: 'Nakopya ang nilalaman! Buksan ang Slack at i-paste ito sa gusto mong channel o DM.',
    pasteTeams: 'Nakopya ang nilalaman! Buksan ang Microsoft Teams at i-paste ito sa gusto mong chat o channel.',
    pasteDiscord: 'Nakopya ang nilalaman! Buksan ang Discord at i-paste ito sa gusto mong server o DM.',
    downloadAppTitle: 'I-download ang Kingdom Bible Quiz',
    downloadAppMessage: 'Kunin ang buong karanasan na may libu-libong tanong, multiplayer na laro, at marami pa!',
    checkoutCompleteTitle: 'Kumpleto ang Checkout',
    checkoutCompleteMessage: 'Kinukumpirma ng Stripe ang iyong subscription. Malapit nang ma-refresh ang premium access.',
    checkoutCancelledTitle: 'Nakansela ang Checkout',
    checkoutCancelledMessage: 'Walang nakumpletong bayad. Maaari kang bumalik sa Premium kapag handa ka na.',
    checkEmailTitle: 'Tingnan ang Iyong Email 📧',
    checkEmailMessage: 'Nagpadala kami ng confirmation link sa:\n\n{{email}}\n\nTingnan ang iyong inbox at spam folder, pagkatapos ay i-click ang link para i-activate ang iyong account.',
    emailSentTitle: 'Naipadala ang Email ✅',
    emailSentMessage: 'Tingnan ang iyong inbox para sa confirmation link.',
    emailSentBanner: 'Naipadala ang email! Tingnan ang iyong inbox.',
    premiumRequiredTitle: 'Kailangan ang Premium',
    premiumRequiredMessage: 'Nangangailangan ng premium subscription ang kategoryang ito. Mag-upgrade para ma-unlock ang lahat ng {{count}} premium na kategorya!',
    upgradeNow: 'Mag-upgrade Ngayon',
    categoryLockedTitle: 'Naka-lock ang Kategorya',
    categoryLockedMessage: 'Abutin ang level {{level}} para ma-unlock ang "{{category}}". Level {{current}} ka ngayon.',
    referralLoadFailed: 'Hindi ma-load ang impormasyon ng referral',
    referralLinkCopied: 'Nakopya sa clipboard ang referral link',
    referralCodeCopied: 'Nakopya sa clipboard ang referral code',
    shareFailed: 'Hindi naibahagi',
    shareMessageFailed: 'Hindi naibahagi ang mensahe',
    shareEmailFailed: 'Hindi naibahagi ang email',
    comingSoonTitle: 'Malapit Na',
    socialSharingSoon: 'Malapit nang maging available ang pagbabahagi sa social media!',
    purchaseLoginRequired: 'Kailangan mong naka-log in para bumili ng subscription',
    purchaseFailedTitle: 'Nabigo ang Pagbili',
    purchaseFailedMessage: 'Hindi makumpleto ang pagbili',
    purchaseError: 'May naganap na error sa pagbili',
    restoreLoginRequired: 'Kailangan mong naka-log in para maibalik ang mga pagbili',
    noPurchasesFound: 'Walang Nahanap na Pagbili',
    noPurchasesMessage: 'Walang nahanap na dating pagbili na maibabalik',
    restoreFailedTitle: 'Nabigo ang Pagbabalik',
    restoreFailedMessage: 'Hindi maibalik ang mga pagbili',
    restoreError: 'May naganap na error habang ibinabalik ang mga pagbili',
    notAuthenticated: 'Hindi naka-authenticate ang user.',
    avatarUpdateFailed: 'Hindi na-update ang avatar.',
    uploadErrorTitle: 'Error sa Pag-upload',
    avatarUploadFailed: 'Hindi na-upload ang avatar.',
    planInfoMissingShort: 'Kulang ang impormasyon ng plan. Pakisubukang muli.',
    startGameFailed: 'Hindi nasimulan ang laro. Pakisubukang muli.',
    scoreBreakdown: 'Detalye ng Iyong Iskor:',
    leaderboardTitle: 'Leaderboard',
    previous: 'Nakaraan',
    next: 'Susunod',
    back: 'Bumalik',
    ready: 'Handa',
    beta: 'Beta',
    soon: 'Malapit na',
    shareDailyQuiz: 'Ibahagi ang Daily Quiz',
    logoAlt: 'Logo ng Kingdom Bible Quiz App',
    copiedTitle: 'Nakopya!',
    shareTextCopied: 'Nakopya sa clipboard ang text na ibabahagi',
    loadingChallenge: 'Nilo-load ang hamon ngayon…',
    questionNotFound: 'Hindi nahanap ang tanong',
    questionOfTheDay: 'Tanong ng Araw',
    groupChallenge: 'Hamon ng Grupo',
    explanation: 'Paliwanag',
    shareResult: 'Ibahagi ang Resulta',
    downloadFullApp: 'I-download ang Buong App',
    demoFamilyName: 'Ang Pamilya Johnson',
    demoFriendsGroupName: 'Grupo ng Kabataan',
    errorTitle: 'Error',
    successTitle: 'Tagumpay',
    ok: 'OK',
    accept: 'Tanggapin',
    decline: 'Tanggihan',
    cancel: 'Kanselahin',
    done: 'Tapos na',
    notNow: 'Hindi muna',
    maybeLater: 'Baka Mamaya',
    tryAgain: 'Subukang Muli',
    loadingQuestion: 'Nilo-load ang tanong…',
    loadingQuiz: 'Nilo-load ang quiz…',
    loadingPlans: 'Nilo-load ang mga subscription plan…',
    checkingPermissions: 'Sinusuri ang mga pahintulot…',
    accessDenied: 'Tinanggihan ang access',
    noLeaderboardData: 'Walang data ng leaderboard',
    createGroupTitle: 'Gumawa ng Grupo ng Pamilya o Kaibigan',
    joinFriendsTitle: 'Sumali sa Mga Kaibigan gamit ang Invite Code',
    inviteCodePlaceholder: 'Ilagay ang invite code…',
    joinFriendsFailed: 'Hindi nakasali sa grupo ng mga kaibigan.',
    leaderboardJoinPrompt: 'Sumali o gumawa ng grupo para makita ang leaderboard!',
    pendingInvitations: 'Mga Nakabinbing Imbitasyon',
    hostBadgeHint: 'Ang manlalarong ito ang host ng kuwarto at maaaring magsimula ng laro.',
    youBadgeHint: 'Ikaw ito! Ikaw lang ang makakakita ng badge na ito.',
    noValidRoomId: 'Walang wastong room ID.',
    userNotFoundSignIn: 'Hindi nahanap ang user. Mag-sign in muli.',
    planInfoMissing: 'Kulang ang impormasyon ng kasalukuyang plan. Pakisubukang muli.',
    billingPerkYearly1: 'Isang bayad kada taon - mas kaunting abala',
    billingPerkYearly2: 'I-lock ang kasalukuyang presyo sa buong taon',
    billingPerkMonthly1: 'Mas flexible sa pagpapalit ng plan',
    billingPerkMonthly2: 'Mas maliit na buwanang bayad',
    billingPerkMonthly3: 'Madaling i-budget kada buwan',
    gateUnlimited: 'Walang limitasyong pang-araw-araw na quiz',
    gateFamilyPlay: 'Paglalaro ng pamilya at sama-samang karanasan',
    gateFamilyGrowth: 'Paglalaro ng pamilya at sama-samang paglago',
    gateInsights: 'Mas malalim na pananaw at debosyonal',
    gateFormats: 'Naka-unlock ang lahat ng format ng tanong',
    signInRequired: 'Kailangan ang Pag-sign In',
    signInToAccessPremium: 'Mag-sign in para magamit ang mga premium na feature.',
    premiumFeatureGroups: 'Gumawa ng mga grupo sa pag-aaral ng Bibliya kasama ang pamilya at kaibigan',
    premiumFeatureHost: 'Mag-host ng mga session ng Bible quiz ng pamilya',
    premiumFeatureTrack: 'Subaybayan ang mga iskor at progreso ng pamilya',
    availableIn: 'Available Sa',
    plansLoadFailed: 'Hindi ma-load ang mga subscription plan. Pakisubukang muli.',
    userNotFoundTryAgain: 'Hindi nahanap ang user. Pakisubukang muli.',
    subscriptionCanceled: 'Nakansela ang Subscription',
    subscriptionCanceledMessage: 'Kinansela na ang iyong subscription at magtatapos ito sa kasalukuyang panahon.',
    cancelFailed: 'Hindi nakansela ang subscription. Pakisubukang muli.',
    unexpectedError: 'May naganap na hindi inaasahang error. Pakisubukang muli.',
    previewMode: 'Preview Mode',
    secureCheckout: 'Ligtas na hosted Stripe Checkout',
    noCardDetails: 'Walang card details na inilalagay sa app',
    currentSubscription: 'Kasalukuyang Subscription',
    termsOfUse: 'Mga Tuntunin ng Paggamit (EULA)',
    privacyPolicy: 'Patakaran sa Privacy',
    cancelPlan: 'Kanselahin ang Plan',
    mostPopular: 'PINAKASIKAT',
    currentPlanBadge: 'KASALUKUYANG PLAN',
    preview: 'Preview',
    planLimits: 'Mga Limitasyon ng Plan:',
    planMembers: 'Hanggang {{count}} miyembro',
    planMembersUnlimited: 'Walang limitasyong miyembro',
    selected: 'Napili ✓',
    selectPlan: 'Piliin ang Plan',
    featUnlimitedQuiz: '30,000+ tanong na may walang limitasyong pang-araw-araw na access',
    featAdFree: 'Karanasang walang ad',
    featHistory: 'Walang limitasyong kasaysayan ng quiz',
    featFormats: '5 magkakaibang format ng tanong (MCQ, Tama/Mali, Punan ang Patlang, Pagsunud-sunod)',
    featLanguages: '10 wika ang available (marami pang darating)',
    featMpCreate: 'Gumawa ng multiplayer quiz room',
    featMpJoin: 'Sumali sa multiplayer quiz room',
    featFamilyAnalytics: 'Pagsubaybay sa progreso ng pamilya',
    featTeam: 'Mag-imbita ng hanggang {{count}} miyembro ng pamilya',
    featPacks: 'Premium na quiz pack',
    signInFailed: 'Nabigo ang Pag-sign In',
    signInFailedMessage: 'Hindi makumpleto ang pag-sign in. Pakisubukang muli.',
    signInError: 'Error sa Pag-sign In',
    quizUnavailable: 'Hindi Available ang Quiz',
    quizLinkInvalid: 'Di-wasto o nag-expire na ang link ng quiz na ito.',
    navigationError: 'Error sa Nabigasyon',
    openQuizFailed: 'Hindi nabuksan ang quiz. Pakisubukang muli.',
    invalidLink: 'Di-wastong Link',
    roomInviteInvalid: 'Di-wasto o nag-expire na ang link ng imbitasyon sa kuwarto.',
    openRoomFailed: 'Hindi nabuksan ang imbitasyon sa kuwarto. Pakisubukang muli.',
    eventInviteInvalid: 'Di-wasto o nag-expire na ang link ng imbitasyon sa event.',
    eventLinkUnavailable: 'Hindi Available ang Link ng Event',
    eventLinksUnsupported: 'Hindi na sinusuportahan sa app na ito ang mga live event link.',
    referralInvalid: 'Di-wasto ang referral link na ito.',
    alreadyRegistered: 'Nakarehistro Na',
    alreadyRegisteredMessage: 'May account ka na! Ibahagi ang app na ito sa mga kaibigang hindi pa nakakasali.',
    joinKbqTitle: 'Sumali sa Kingdom Bible Quiz!',
    joinKbqMessage: 'Inimbitahan ka sa pinakamahusay na Bible quiz app. Gumawa ng account para magsimula!',
    signUp: 'Mag-sign Up',
    signupNavFailed: 'Hindi nabuksan ang pag-sign up. Pakisubukang muli.',
    exploredAll: 'Nakapag-explore na ang iyong pamilya ng {{count}} tanong',
    exploredWeek: 'Nakapag-explore ang iyong pamilya ng {{count}} tanong ngayong linggo',
    exploredMonth: 'Nakapag-explore ang iyong pamilya ng {{count}} tanong ngayong buwan',
    filterWeek: 'Ngayong Linggo',
    filterMonth: 'Ngayong Buwan',
    filterAll: 'Lahat ng Panahon',
    entryStats: '{{questions}} tanong na na-explore · {{quizzes}} quiz',
    readyToStart: 'Handa nang magsimula!',
    statQuizzesTogether: 'Mga Quiz\nSama-sama',
    statQuestionsExplored: 'Mga Tanong\nNa-explore',
    statMembersActive: 'Aktibong\nMiyembro',
  },
  am: {
    successBang: 'ተሳክቷል!',
    great: 'እሺ ጥሩ!',
    billingUpdatedTitle: 'ክፍያ ተዘምኗል!',
    billingSwitchedAnnual: 'ክፍያዎ ወደ ዓመታዊ ተቀይሯል። አሁን በዓመት {{percent}}% ይቆጥባሉ!',
    billingSwitchedMonthly: 'ክፍያዎ ወደ ወርሃዊ ተቀይሯል። የሚቀጥለው ክፍያዎ ወርሃዊ ይሆናል።',
    billingChangeFailedTitle: 'የክፍያ ለውጥ አልተሳካም',
    billingChangeFailedMessage: 'የክፍያ ዑደትዎን መቀየር አልተቻለም። እባክዎ እንደገና ይሞክሩ።',
    planUpgraded: 'ምዝገባዎ ወደ {{plan}} ተሻሽሏል። አዲሶቹ ባህሪያትዎ አሁን ንቁ ናቸው!',
    planDowngraded: 'ምዝገባዎ ወደ {{plan}} ተቀይሯል። አዲሶቹ ባህሪያትዎ አሁን ንቁ ናቸው!',
    planChanged: 'ምዝገባዎ ወደ {{plan}} ተቀይሯል። አዲሶቹ ባህሪያትዎ አሁን ንቁ ናቸው!',
    planChangeFailedTitle: 'የዕቅድ ለውጥ አልተሳካም',
    planChangeFailedMessage: 'ዕቅድዎን መቀየር አልተቻለም። እባክዎ እንደገና ይሞክሩ።',
    subscriptionActivated: 'ምዝገባዎ ነቅቷል። አመሰግናለሁ!',
    purchasesRestoredTitle: 'ግዢዎች ተመልሰዋል',
    purchasesRestoredMessage: '{{count}} ምዝገባ(ዎች) በተሳካ ሁኔታ ተመልሰዋል',
    stripeSignInMessage: 'የStripe ክፍያ ከመጀመርዎ በፊት ይግቡ ወይም መለያ ይፍጠሩ። የእንግዳ እድገትዎ ከገቡ በኋላ ሊተላለፍ ይችላል።',
    previewSuccess: 'ምዝገባው በተሳካ ሁኔታ ተመስሏል! በቀጥታ ሁነታ ክፍያ ይከናወናል።',
    welcomeSubscription: 'እንኳን ወደ አዲሱ ምዝገባዎ በደህና መጡ! የፕሪሚየም ባህሪያትዎ አሁን ንቁ ናቸው።',
    processSubscriptionFailed: 'ምዝገባውን ማስኬድ አልተቻለም። እባክዎ እንደገና ይሞክሩ።',
    startGameFailedTitle: 'ጨዋታውን መጀመር አልተቻለም',
    joinRoomFailed: 'ወደ ክፍሉ መቀላቀል አልተቻለም። እባክዎ እንደገና ይሞክሩ።',
    joinRoomFailedWithReason: 'ወደ ክፍሉ መቀላቀል አልተቻለም፦ {{message}}',
    unknownError: 'ያልታወቀ ስህተት',
    sharedSuccessTitle: 'በተሳካ ሁኔታ ተጋርቷል!',
    sharedSuccessMessage: 'ጥያቄዎ በ{{platform}} ተጋርቷል። የመጽሐፍ ቅዱስ እውቀትን ስላሰራጩ እናመሰግናለን!',
    shareAnother: 'ሌላ አጋራ',
    sharingFailedTitle: 'ማጋራት አልተሳካም',
    sharingFailedMessage: 'በ{{platform}} ማጋራት አልተቻለም። እባክዎ እንደገና ይሞክሩ።',
    sharingErrorTitle: 'የማጋራት ስህተት',
    sharingErrorMessage: 'ወደ {{platform}} በማጋራት ወቅት ስህተት ተፈጥሯል። እባክዎ እንደገና ይሞክሩ።',
    platformSharingTitle: '{{platform}} ማጋራት',
    soonInstagram: 'በInstagram ማጋራት መተግበሪያውን አስቀድሞ በተሞላ ይዘት ይከፍታል። ይህ ባህሪ በቅርቡ ይመጣል!',
    soonTikTok: 'በTikTok ማጋራት ከጥያቄዎ ማራኪ ቪዲዮ ይፈጥራል። ይህ ባህሪ በመስተጋብራዊ የቪዲዮ ቅንብሮች በቅርቡ ይመጣል!',
    soonSnapchat: 'በSnapchat ማጋራት ከጥያቄዎችዎ ምስላዊ ታሪኮችን ይፈጥራል። ይህ ባህሪ በቅርቡ ይመጣል!',
    soonYouTube: 'በYouTube ማጋራት የጥያቄ ይዘትን በማህበረሰብ ትር ወይም በቪዲዮ መግለጫዎች ላይ ለመለጠፍ ያስችልዎታል። ይህ ባህሪ በቅርቡ ይመጣል!',
    linkCopiedTitle: 'ሊንክ ተቀድቷል!',
    linkCopiedMessage: 'የጥያቄው ሊንክ ወደ ክሊፕቦርድ ተቀድቷል። ለማጋራት በፈለጉበት ቦታ መለጠፍ ይችላሉ።',
    shareToSlack: 'ወደ Slack አጋራ',
    shareToTeams: 'ወደ Microsoft Teams አጋራ',
    shareToDiscord: 'ወደ Discord አጋራ',
    pasteSlack: 'ይዘቱ ተቀድቷል! Slack ይክፈቱና በሚፈልጉት ቻናል ወይም DM ይለጥፉ።',
    pasteTeams: 'ይዘቱ ተቀድቷል! Microsoft Teams ይክፈቱና በሚፈልጉት ውይይት ወይም ቻናል ይለጥፉ።',
    pasteDiscord: 'ይዘቱ ተቀድቷል! Discord ይክፈቱና በሚፈልጉት ሰርቨር ወይም DM ይለጥፉ።',
    downloadAppTitle: 'Kingdom Bible Quiz አውርድ',
    downloadAppMessage: 'በሺዎች የሚቆጠሩ ጥያቄዎች፣ የብዙ ተጫዋች ጨዋታዎችና ሌሎችም ያሉት ሙሉውን ተሞክሮ ያግኙ!',
    checkoutCompleteTitle: 'ክፍያ ተጠናቋል',
    checkoutCompleteMessage: 'Stripe ምዝገባዎን እያረጋገጠ ነው። የፕሪሚየም መዳረሻ በቅርቡ ይታደሳል።',
    checkoutCancelledTitle: 'ክፍያ ተሰርዟል',
    checkoutCancelledMessage: 'ምንም ክፍያ አልተጠናቀቀም። ሲዘጋጁ ወደ ፕሪሚየም መመለስ ይችላሉ።',
    checkEmailTitle: 'ኢሜይልዎን ያረጋግጡ 📧',
    checkEmailMessage: 'የማረጋገጫ ሊንክ ወደ ይህ ልከናል፦\n\n{{email}}\n\nየገቢ መልዕክት ሳጥንዎንና የስፓም አቃፊዎን ይመልከቱ፣ ከዚያ መለያዎን ለማንቃት ሊንኩን ይጫኑ።',
    emailSentTitle: 'ኢሜይል ተልኳል ✅',
    emailSentMessage: 'የማረጋገጫ ሊንኩን በገቢ መልዕክት ሳጥንዎ ይመልከቱ።',
    emailSentBanner: 'ኢሜይል ተልኳል! የገቢ መልዕክት ሳጥንዎን ይመልከቱ።',
    premiumRequiredTitle: 'ፕሪሚየም ያስፈልጋል',
    premiumRequiredMessage: 'ይህ ምድብ የፕሪሚየም ምዝገባ ይፈልጋል። ሁሉንም {{count}} የፕሪሚየም ምድቦች ለመክፈት ያሻሽሉ!',
    upgradeNow: 'አሁን ያሻሽሉ',
    categoryLockedTitle: 'ምድቡ ተቆልፏል',
    categoryLockedMessage: '"{{category}}"ን ለመክፈት ደረጃ {{level}} ይድረሱ። አሁን በደረጃ {{current}} ላይ ነዎት።',
    referralLoadFailed: 'የሪፈራል መረጃን መጫን አልተቻለም',
    referralLinkCopied: 'የሪፈራል ሊንክ ወደ ክሊፕቦርድ ተቀድቷል',
    referralCodeCopied: 'የሪፈራል ኮድ ወደ ክሊፕቦርድ ተቀድቷል',
    shareFailed: 'ማጋራት አልተሳካም',
    shareMessageFailed: 'መልዕክቱን ማጋራት አልተቻለም',
    shareEmailFailed: 'በኢሜይል ማጋራት አልተቻለም',
    comingSoonTitle: 'በቅርቡ ይመጣል',
    socialSharingSoon: 'በማህበራዊ ሚዲያ ማጋራት በቅርቡ ይገኛል!',
    purchaseLoginRequired: 'ምዝገባ ለመግዛት መግባት አለብዎት',
    purchaseFailedTitle: 'ግዢው አልተሳካም',
    purchaseFailedMessage: 'ግዢውን ማጠናቀቅ አልተቻለም',
    purchaseError: 'በግዢ ወቅት ስህተት ተፈጥሯል',
    restoreLoginRequired: 'ግዢዎችን ለመመለስ መግባት አለብዎት',
    noPurchasesFound: 'ምንም ግዢ አልተገኘም',
    noPurchasesMessage: 'ለመመለስ ምንም ቀደም ያለ ግዢ አልተገኘም',
    restoreFailedTitle: 'መመለስ አልተሳካም',
    restoreFailedMessage: 'ግዢዎችን መመለስ አልተቻለም',
    restoreError: 'ግዢዎችን በመመለስ ወቅት ስህተት ተፈጥሯል',
    notAuthenticated: 'ተጠቃሚው አልተረጋገጠም።',
    avatarUpdateFailed: 'አምሳያውን ማዘመን አልተቻለም።',
    uploadErrorTitle: 'የመጫን ስህተት',
    avatarUploadFailed: 'አምሳያውን መጫን አልተቻለም።',
    planInfoMissingShort: 'የዕቅድ መረጃ ይጎድላል። እባክዎ እንደገና ይሞክሩ።',
    startGameFailed: 'ጨዋታውን መጀመር አልተቻለም። እባክዎ እንደገና ይሞክሩ።',
    scoreBreakdown: 'የውጤትዎ ዝርዝር፦',
    leaderboardTitle: 'የደረጃ ሰንጠረዥ',
    previous: 'ቀዳሚ',
    next: 'ቀጣይ',
    back: 'ተመለስ',
    ready: 'ዝግጁ',
    beta: 'ቤታ',
    soon: 'በቅርቡ',
    shareDailyQuiz: 'ዕለታዊ ጥያቄን አጋራ',
    logoAlt: 'የKingdom Bible Quiz መተግበሪያ አርማ',
    copiedTitle: 'ተቀድቷል!',
    shareTextCopied: 'የማጋሪያ ጽሑፍ ወደ ክሊፕቦርድ ተቀድቷል',
    loadingChallenge: 'የዛሬው ፈተና በመጫን ላይ…',
    questionNotFound: 'ጥያቄው አልተገኘም',
    questionOfTheDay: 'የቀኑ ጥያቄ',
    groupChallenge: 'የቡድን ፈተና',
    explanation: 'ማብራሪያ',
    shareResult: 'ውጤቱን አጋራ',
    downloadFullApp: 'ሙሉውን መተግበሪያ አውርድ',
    demoFamilyName: 'የጆንሰን ቤተሰብ',
    demoFriendsGroupName: 'የወጣቶች ቡድን',
    errorTitle: 'ስህተት',
    successTitle: 'ተሳክቷል',
    ok: 'እሺ',
    accept: 'ተቀበል',
    decline: 'አልቀበልም',
    cancel: 'ሰርዝ',
    done: 'ተጠናቋል',
    notNow: 'አሁን አይደለም',
    maybeLater: 'ምናልባት በኋላ',
    tryAgain: 'እንደገና ሞክር',
    loadingQuestion: 'ጥያቄ በመጫን ላይ…',
    loadingQuiz: 'ጥያቄ በመጫን ላይ…',
    loadingPlans: 'የምዝገባ ዕቅዶች በመጫን ላይ…',
    checkingPermissions: 'ፈቃዶችን በመፈተሽ ላይ…',
    accessDenied: 'መዳረሻ ተከልክሏል',
    noLeaderboardData: 'የደረጃ ሰንጠረዥ መረጃ የለም',
    createGroupTitle: 'የቤተሰብ ወይም የጓደኞች ቡድን ፍጠር',
    joinFriendsTitle: 'በግብዣ ኮድ ወደ ጓደኞች ይቀላቀሉ',
    inviteCodePlaceholder: 'የግብዣ ኮድ ያስገቡ…',
    joinFriendsFailed: 'ወደ ጓደኞች ቡድን መቀላቀል አልተቻለም።',
    leaderboardJoinPrompt: 'የደረጃ ሰንጠረዡን ለማየት ቡድን ይቀላቀሉ ወይም ይፍጠሩ!',
    pendingInvitations: 'በመጠባበቅ ላይ ያሉ ግብዣዎች',
    hostBadgeHint: 'ይህ ተጫዋች የክፍሉ አስተናጋጅ ሲሆን ጨዋታውን መጀመር ይችላል።',
    youBadgeHint: 'ይህ እርስዎ ነዎት! ይህን ባጅ እርስዎ ብቻ ያዩታል።',
    noValidRoomId: 'ትክክለኛ የክፍል መታወቂያ የለም።',
    userNotFoundSignIn: 'ተጠቃሚው አልተገኘም። እባክዎ እንደገና ይግቡ።',
    planInfoMissing: 'የአሁኑ ዕቅድ መረጃ ይጎድላል። እባክዎ እንደገና ይሞክሩ።',
    billingPerkYearly1: 'በዓመት አንድ ክፍያ - ያነሰ ችግር',
    billingPerkYearly2: 'የአሁኑን ዋጋ ለሙሉ ዓመት ይቆልፉ',
    billingPerkMonthly1: 'ዕቅዶችን ለመቀየር የበለጠ ተለዋዋጭነት',
    billingPerkMonthly2: 'አነስተኛ ወርሃዊ ክፍያዎች',
    billingPerkMonthly3: 'በየወሩ ለበጀት ቀላል',
    gateUnlimited: 'ያልተገደበ ዕለታዊ ጥያቄዎች',
    gateFamilyPlay: 'የቤተሰብ ጨዋታና የጋራ ተሞክሮዎች',
    gateFamilyGrowth: 'የቤተሰብ ጨዋታና የጋራ እድገት',
    gateInsights: 'ጥልቅ ማስተዋልና ጸሎቶች',
    gateFormats: 'ሁሉም የጥያቄ ዓይነቶች ተከፍተዋል',
    signInRequired: 'መግባት ያስፈልጋል',
    signInToAccessPremium: 'ፕሪሚየም ባህሪያትን ለመጠቀም እባክዎ ይግቡ።',
    premiumFeatureGroups: 'ከቤተሰብና ከጓደኞች ጋር የመጽሐፍ ቅዱስ ጥናት ቡድኖችን ይፍጠሩ',
    premiumFeatureHost: 'የቤተሰብ የመጽሐፍ ቅዱስ ጥያቄ ክፍለ ጊዜዎችን ያስተናግዱ',
    premiumFeatureTrack: 'ውጤቶችንና የቤተሰብ እድገትን ይከታተሉ',
    availableIn: 'የሚገኝበት',
    plansLoadFailed: 'የምዝገባ ዕቅዶችን መጫን አልተቻለም። እባክዎ እንደገና ይሞክሩ።',
    userNotFoundTryAgain: 'ተጠቃሚው አልተገኘም። እባክዎ እንደገና ይሞክሩ።',
    subscriptionCanceled: 'ምዝገባ ተሰርዟል',
    subscriptionCanceledMessage: 'ምዝገባዎ ተሰርዟል፣ በአሁኑ ጊዜ መጨረሻ ላይ ይቆማል።',
    cancelFailed: 'ምዝገባውን መሰረዝ አልተቻለም። እባክዎ እንደገና ይሞክሩ።',
    unexpectedError: 'ያልተጠበቀ ስህተት ተፈጥሯል። እባክዎ እንደገና ይሞክሩ።',
    previewMode: 'የቅድመ እይታ ሁነታ',
    secureCheckout: 'ደህንነቱ የተጠበቀ የStripe ክፍያ',
    noCardDetails: 'በመተግበሪያው ውስጥ የካርድ ዝርዝር አይገባም',
    currentSubscription: 'የአሁኑ ምዝገባ',
    termsOfUse: 'የአጠቃቀም ውሎች (EULA)',
    privacyPolicy: 'የግላዊነት መመሪያ',
    cancelPlan: 'ዕቅዱን ሰርዝ',
    mostPopular: 'በጣም ተወዳጅ',
    currentPlanBadge: 'የአሁኑ ዕቅድ',
    preview: 'ቅድመ እይታ',
    planLimits: 'የዕቅድ ገደቦች፦',
    planMembers: 'እስከ {{count}} አባላት',
    planMembersUnlimited: 'ያልተገደበ አባላት',
    selected: 'ተመርጧል ✓',
    selectPlan: 'ዕቅድ ምረጥ',
    featUnlimitedQuiz: 'ከ30,000 በላይ ጥያቄዎች ያለ ገደብ በየቀኑ',
    featAdFree: 'ከማስታወቂያ ነፃ ተሞክሮ',
    featHistory: 'ያልተገደበ የጥያቄ ታሪክ',
    featFormats: '5 የተለያዩ የጥያቄ ዓይነቶች (ምርጫ፣ እውነት/ሐሰት፣ ባዶ ሙላ፣ ማደራጀት)',
    featLanguages: '10 ቋንቋዎች ይገኛሉ (ተጨማሪ በቅርቡ)',
    featMpCreate: 'የብዙ ተጫዋች ጥያቄ ክፍሎችን ይፍጠሩ',
    featMpJoin: 'ወደ ብዙ ተጫዋች ጥያቄ ክፍሎች ይቀላቀሉ',
    featFamilyAnalytics: 'የቤተሰብ እድገት መከታተል',
    featTeam: 'እስከ {{count}} የቤተሰብ አባላትን ይጋብዙ',
    featPacks: 'ፕሪሚየም የጥያቄ ጥቅሎች',
    signInFailed: 'መግባት አልተሳካም',
    signInFailedMessage: 'መግባቱን ማጠናቀቅ አልተቻለም። እባክዎ እንደገና ይሞክሩ።',
    signInError: 'የመግባት ስህተት',
    quizUnavailable: 'ጥያቄው አይገኝም',
    quizLinkInvalid: 'ይህ የጥያቄ ሊንክ ልክ አይደለም ወይም ጊዜው አልፎበታል።',
    navigationError: 'የአሰሳ ስህተት',
    openQuizFailed: 'ጥያቄውን መክፈት አልተቻለም። እባክዎ እንደገና ይሞክሩ።',
    invalidLink: 'ልክ ያልሆነ ሊንክ',
    roomInviteInvalid: 'ይህ የክፍል ግብዣ ሊንክ ልክ አይደለም ወይም ጊዜው አልፎበታል።',
    openRoomFailed: 'ይህን የክፍል ግብዣ መክፈት አልተቻለም። እባክዎ እንደገና ይሞክሩ።',
    eventInviteInvalid: 'ይህ የክስተት ግብዣ ሊንክ ልክ አይደለም ወይም ጊዜው አልፎበታል።',
    eventLinkUnavailable: 'የክስተት ሊንክ አይገኝም',
    eventLinksUnsupported: 'የቀጥታ ክስተት ሊንኮች በዚህ መተግበሪያ ውስጥ ከእንግዲህ አይደገፉም።',
    referralInvalid: 'ይህ የሪፈራል ሊንክ ልክ አይደለም።',
    alreadyRegistered: 'ቀድሞ ተመዝግበዋል',
    alreadyRegisteredMessage: 'አስቀድመው መለያ አለዎት! ይህን መተግበሪያ ገና ላልተቀላቀሉ ጓደኞች ያጋሩ።',
    joinKbqTitle: 'Kingdom Bible Quiz ይቀላቀሉ!',
    joinKbqMessage: 'ወደ ምርጡ የመጽሐፍ ቅዱስ ጥያቄ መተግበሪያ ተጋብዘዋል። ለመጀመር መለያዎን ይፍጠሩ!',
    signUp: 'ተመዝገብ',
    signupNavFailed: 'ወደ ምዝገባ መሄድ አልተቻለም። እባክዎ እንደገና ይሞክሩ።',
    exploredAll: 'ቤተሰብዎ {{count}} ጥያቄዎችን ቃኝቷል',
    exploredWeek: 'ቤተሰብዎ በዚህ ሳምንት {{count}} ጥያቄዎችን ቃኝቷል',
    exploredMonth: 'ቤተሰብዎ በዚህ ወር {{count}} ጥያቄዎችን ቃኝቷል',
    filterWeek: 'በዚህ ሳምንት',
    filterMonth: 'በዚህ ወር',
    filterAll: 'ሁሉም ጊዜ',
    entryStats: '{{questions}} ጥያቄዎች ተቃኝተዋል · {{quizzes}} ጥያቄዎች',
    readyToStart: 'ለመጀመር ዝግጁ!',
    statQuizzesTogether: 'በጋራ\nጥያቄዎች',
    statQuestionsExplored: 'የተቃኙ\nጥያቄዎች',
    statMembersActive: 'ንቁ\nአባላት',
  },
};
